import { Component, OnInit } from '@angular/core';
import { ProjectServicesService } from '../shared/services/project-services.service';
import { SharedService } from '../shared/services/shared.service';
import { Config } from '../config';
import { AppService } from '../shared/services/app.service';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { faCircle, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { ReportDataRxjsService } from '../shared/services/report-data-rxjs.service';
declare var $: any;
@Component({
  selector: 'app-export-report',
  templateUrl: './export-report.component.html',
  styleUrls: ['./export-report.component.scss'],
})
export class ExportReportComponent implements OnInit {
  faCircle = faCircle;
  faCheckCircle = faCheckCircle;
  constructor(
    private ProjectServices: ProjectServicesService,
    private _sharedService: SharedService,
    private Config: Config,
    private cookieService: CookieService,
    private AppService: AppService,
    public translate: TranslateService,
    private ReportDataRxjsService: ReportDataRxjsService
  ) {
    const browserLang = this.cookieService.get('language');
    translate.use(browserLang.match(/en|jp/) ? browserLang : 'en');

  }

  myTopScrollBtn = document.getElementById('scrollToTpBtn');
  modelValue: any = '';
  project: any = '';
  projectName: any = '';
  userName: any = '';
  currentDate: any = '';
  toolReportName: any = '';
  checklistType: any = '';
  selectedPlanname: any = '';
  mappedAttributesWithEUTs: any = '';
  entitiesWithNoScenarios: any = [];
  levels = ["L8", "L7", "L6", "L5", "L4", "L123"];
  listOfAttributes = [
    {
      name: 'Feature Behaviour',
      symbol: 'Fe',
      level: 'L4',
    },
    {
      name: 'Requirement Behaviour',
      symbol: 'Rb',
      level: 'L5',
    },
    {
      name: 'Flow Behaviour',
      symbol: 'Fb',
      level: 'L5',
    },
    {
      name: 'Migration',
      symbol: 'Mi',
      level: 'L8',
    },
    {
      name: 'Installation',
      symbol: 'In',
      level: 'L8',
    },
    {
      name: 'Configuration',
      symbol: 'Co',
      level: 'L8',
    },
    {
      name: 'System Integration',
      symbol: 'Si',
      level: 'L8',
    },
    {
      name: 'Performance',
      symbol: 'Pf',
      level: 'L7',
    },
    {
      name: 'Load',
      symbol: 'Lo',
      level: 'L7',
    },
    {
      name: 'Reliability',
      symbol: 'Re',
      level: 'L7',
    },
    {
      name: 'Security',
      symbol: 'Se',
      level: 'L7',
    },
    {
      name: 'Usability',
      symbol: 'Us',
      level: 'L7',
    },
    {
      name: 'Browser Compatibility',
      symbol: 'Bc',
      level: 'L6',
    },
    {
      name: 'Environment Compatibility',
      symbol: 'Ec',
      level: 'L6',
    },
    {
      name: 'Access Control',
      symbol: 'Ac',
      level: 'L4',
    },
    {
      name: 'UI Interface',
      symbol: 'Ui',
      level: 'L123',
    },
    {
      name: 'Structural Behaviour',
      symbol: 'St',
      level: 'L123',
    },
    // {
    //   name: 'Data Validation',
    //   symbol: 'Dt',
    //   level: 'L123',
    // },
  ];
  featureArray: any = [];
  requirementArray: any = [];
  flowArray: any = [];
  unspecifiedArray: any = [];
  DetailAttribute: any = [];
  nonDetailAttribute: any = [];
  model: any = '';
  indexVal = 0;
  scenarioIndex = 0;
  exportedData: any = [];
  selectedEntities: any;
  scenarioEntities: any;
  matchedSelectedEUT: any;
  selectedEUT: any;
  projectId: any;
  matchedEntity: any = '';
  matchedTaskAttribute: any = '';
  eTypeInteraction: any = '';
  runInfo: any = '';
  matchedEUT: any;
  matchedAttr: any = '';
  selectedChecklist: any = {};
  matchedPersona: any = '';
  matchedAttribute: any = '';
  attributesDesigner: any = '';
  // scenarioEntities: any = [];
  actualEntitiesArray: any = [];
  plannedEntitiesArray: any = [];
  totalEntitiesArray: any = [];
  plannedEntitesTFArray: any = [];
  actualEntitesTFArray: any = [];
  plannedEntitesURArray: any = [];
  actualEntitesURArray: any = [];
  plannedEntitesBFArray: any = [];
  actualEntitesBFArray: any = [];
  finalSprintTasksArray: any = [];
  clubbedAttributesArray: any = [];
  ngOnInit(): void {
    // language = $cookies.getObject("language");
    // $translate.use(language);

    this.userName = window.localStorage.getItem('userName');
    this.projectName = window.localStorage.getItem('projectName');
    this.projectId = window.localStorage.getItem('projectID');
    this.ProjectServices.getProject(
      window.localStorage.getItem('projectID')
    ).subscribe((response: any) => {
      // console.log('resss', response);
      if (response.statusCode == 200) {
        this.project = response.record;
        console.log('this.project', this.project);
        this.loadModel(this.project);
      } else {
      }
    });
    this.currentDate = new Date();
    this.ReportDataRxjsService.data$.subscribe((data) => {
      console.log("data", data);
      // this.project = data;
    });
  }
  //To load the Model data in export report
  loadModel(params: any) {
    this.model = params;
    this.indexVal = 0;
    this.scenarioIndex = 0;
    var exportData: any = window.localStorage.getItem('exportedData');
    this.exportedData = JSON.parse(exportData);
    this.selectedEntities = window.localStorage.getItem('Entities');
    this.scenarioEntities = window.localStorage.getItem('scenarioEntity');
    this.featureArray = [];
    this.requirementArray = [];
    this.flowArray = [];
    this.unspecifiedArray = [];
    this.DetailAttribute = [];
    this.nonDetailAttribute = [];
    this.clubbedAttributesArray = this.Config.listOfAttributesUpdated;

    for (var z = 0; z < this.Config.listofFunctionalityTestTypes.length; z++) {
      this.clubbedAttributesArray.push(this.Config.listofFunctionalityTestTypes[z]);
    }

    for (var j = 0; j < this.Config.listOfAttributesUpdated.length; j++) {
      if (this.getAttributeDesc(this.Config.listOfAttributesUpdated[j]) != '') {
        var specifiedAttribute = this.getSpecifiedAttribute(this.Config.listOfAttributesUpdated[j]);
        this.DetailAttribute.push(specifiedAttribute);
      } else {
        this.nonDetailAttribute.push(this.Config.listOfAttributesUpdated[j]);
      }
    }
    // console.log("this.DetailAttribute",this.DetailAttribute);
    // console.log("this.nonDetailAttribute",this.nonDetailAttribute);
    for (var j = 0; j < this.model.listOfEUTs.length; j++) {
      if (this.model.listOfEUTs[j].eType == 'TF') {
        this.featureArray.push(this.model.listOfEUTs[j]);
      } else if (this.model.listOfEUTs[j].eType == 'UR') {
        this.requirementArray.push(this.model.listOfEUTs[j]);
      } else if (this.model.listOfEUTs[j].eType == 'BF') {
        this.flowArray.push(this.model.listOfEUTs[j]);
      } else {
        this.unspecifiedArray.push(this.model.listOfEUTs[j]);
      }
    }
    // console.log('exportedData', exportedData);
    // for (var k = 0; k < exportedData.length; k++) {
    //   generateContentlist(k + 1, exportedData[k]);
    // }
    for (var i = 0; i < this.exportedData.length; i++) {
      if (this.exportedData[i] == 'Persona') {
        this.toolReportName = 'Landscape Report';
        if (this.exportedData.length == 1) {
          this.generateContentlist(this.exportedData, 'Persona');
        }
        this.indexVal = this.indexVal + 1;
        this.generateHeader(this.indexVal, this.exportedData[i]);
        if (this.model.persona.length != 0) {
          this.generateSubheader(this.exportedData[i], this.model.persona);
          this.generateList(this.model.persona, this.exportedData[i]);
        } else {
          var html = '<div class="row strict">';
          html +=
            '<div class="alert alert-warning"><strong><div >None</div></strong></div>';
          html += '</div>';
          $('#exportSheet').append(html);
        }
        this.generatePersonaMapperTable();
      }
      if (this.exportedData[i] == 'Attributes') {
        this.indexVal = this.indexVal + 1;
        this.generateHeader(this.indexVal, this.exportedData[i]);
        if (this.model.listOfAttributes.length > 0) {
          if (this.DetailAttribute.length > 0) {
            this.generateSubheader(
              'Specified Attributes',
              this.DetailAttribute
            );
            this.generateList(this.DetailAttribute, 'Attributes');
          }
          if (this.nonDetailAttribute.length > 0) {
            this.generateSubheader(
              'Not-Specified Attributes',
              this.nonDetailAttribute
            );
            this.generateList(this.nonDetailAttribute, 'NonAttributes');
          }
        } else {
          var html = '<div class="row strict">';
          html +=
            '<div class="alert alert-warning"><strong><div>None</div></strong></div>';
          html += '</div>';
          $('#exportSheet').append(html);
        }
        this.generateScopeMapperTable();
      }
      if (this.exportedData[i] == 'Summary') {
        this.indexVal = this.indexVal + 1;
        this.generateHeader(this.indexVal, this.exportedData[i]);
        this.generateLandscapeSummaryTable();
      }
      if (this.exportedData[i] == 'Features') {
        this.generateContentlist(this.exportedData, 'Landscape');
        this.toolReportName = 'Landscape Report';
        this.indexVal = this.indexVal + 1;
        this.generateHeader(this.indexVal, this.exportedData[i]);
        if (this.featureArray.length != 0) {
          this.generateSubheader(this.exportedData[i], this.featureArray);
          this.generateList(this.featureArray, this.exportedData[i]);
        } else {
          var html = '<div class="row strict">';
          html +=
            '<div class="alert alert-warning"><strong><div>None</div></strong></div>';
          html += '</div>';
          $('#exportSheet').append(html);
        }
      }
      if (this.exportedData[i] == 'Requirements') {
        this.indexVal = this.indexVal + 1;
        this.generateHeader(this.indexVal, this.exportedData[i]);
        if (this.requirementArray.length != 0) {
          this.generateSubheader(this.exportedData[i], this.requirementArray);
          this.generateList(this.requirementArray, this.exportedData[i]);
        } else {
          var html = '<div class="row strict">';
          html +=
            '<div class="alert alert-warning"><strong><div>None</div></strong></div>';
          html += '</div>';
          $('#exportSheet').append(html);
        }
      }
      if (this.exportedData[i] == 'Modules') {
        this.indexVal = this.indexVal + 1;
        this.generateHeader(this.indexVal, this.exportedData[i]);
        if (this.model.modules.length != 0) {
          this.generateSubheader(this.exportedData[i], this.model.modules);
          this.generateList(this.model.modules, this.exportedData[i]);
        } else {
          var html = '<div class="row strict">';
          html +=
            '<div class="alert alert-warning"><strong><div >None</div></strong></div>';
          html += '</div>';
          $('#exportSheet').append(html);
        }
      }
      if (this.exportedData[i] == 'Flows') {
        this.indexVal = this.indexVal + 1;
        this.generateHeader(this.indexVal, this.exportedData[i]);
        if (this.flowArray.length != 0) {
          this.generateSubheader(this.exportedData[i], this.flowArray);
          this.generateList(this.flowArray, this.exportedData[i]);
        } else {
          var html = '<div class="row strict">';
          html +=
            '<div class="alert alert-warning"><strong><div>None</div></strong></div>';
          html += '</div>';
          $('#exportSheet').append(html);
        }
      }
      if (this.exportedData[i] == 'Unspecified') {
        this.indexVal = this.indexVal + 1;
        this.generateHeader(this.indexVal, this.exportedData[i]);
        if (this.unspecifiedArray.length != 0) {
          this.generateSubheader(this.exportedData[i], this.unspecifiedArray);
          this.generateList(this.unspecifiedArray, this.exportedData[i]);
        } else {
          var html = '<div class="row strict">';
          html +=
            '<div class="alert alert-warning"><strong><div >None</div></strong></div>';
          html += '</div>';
          $('#exportSheet').append(html);
        }
        this.generateInteractionMapperTable();
      }
      if (this.exportedData[i] == 'Environments') {
        this.indexVal = this.indexVal + 1;
        this.generateHeader(this.indexVal, this.exportedData[i]);
        if (this.model.listOfEnv.length != 0) {
          this.generateSubheader(this.exportedData[i], this.model.listOfEnv);
          this.generateSubList(this.model.listOfEnv, this.exportedData[i]);
        } else {
          var html = '<div class="row strict">';
          html +=
            '<div class="alert alert-warning"><strong><div >None</div></strong></div>';
          html += '</div>';
          $('#exportSheet').append(html);
        }
      }
      if (this.exportedData[i] == 'PersonaMapper') {
        this.toolReportName = 'Persona Map Report';
        this.generatePersonaMapperSubList();
      }
      if (this.exportedData[i] == 'InteractionMapper') {
        this.toolReportName = 'Interaction Map Report';
        this.generateInteractionMapperSubList();
      }
      if (this.exportedData[i] == 'ScopeMapper') {
        this.toolReportName = 'Scope Map Report';
        this.generateScopeMapperSubList();
      }
      if (this.exportedData[i] == 'EnvironmentMapper') {
        this.toolReportName = 'Environment Map Report';
        this.generateEnvironmentMapperSubList();
      }
      if (this.exportedData[i] == 'DeepDive') {
        this.toolReportName = 'Deep Dive information of an entity Report';
        this.generateReportsForEntities();
      }
      if (this.exportedData[i] == 'Designer') {
        this.toolReportName = 'Designer - Scenarios of an entity Report';
        this.generateScenariosForEntities();
      }
      if (this.exportedData[i] == 'Executor') {
        this.toolReportName = 'Executor Report';
        this.generateExecutedScenariosForPlans();
      }
      if (this.exportedData[i] == 'Manager') {
        this.toolReportName = 'Test Manager Report';
        // generateScenariosForSuites();
        this.generateScenariosForTestManager();
      }
      if (this.exportedData[i] == 'Task Planner') {
        this.toolReportName = this.exportedData[i] + ' Report';
        // generateScenariosForSuites();
        this.generateTasksForTaskplanner();
      }
      if (this.exportedData[i] == 'Suites') {
        this.toolReportName = this.exportedData[i] + ' Report';
        this.generateScenariosForSuites();
        // generateTasksForTaskplanner();
      }
      if (this.exportedData[i] == 'Notes') {
        this.toolReportName = this.exportedData[i] + ' Report';
        this.generateNotes();
      }
      if (this.exportedData[i] == 'Scenarios') {
        this.toolReportName = this.exportedData[i] + ' Report';
        this.generateScenariosForEUTTypes();
      }
      if (this.exportedData[i] == 'Checklist') {
        this.toolReportName = this.exportedData[i];
        this.generateChecklistReport();
      }
      if (this.exportedData[i] == 'projectSum') {
        this.toolReportName = 'Project Summary Report';
        this.generateProjectSummaryTable();
        this.generateDesignSummaryTable();
      }
      if (this.exportedData[i] == 'designSum') {
        this.toolReportName = 'Design Summary Report';
        this.generateDesignSummaryTable();
      }
    }
    // autoDownload = window.localStorage.getItem("autoDownload");
    // if (autoDownload == 'true') {
    //   $('#cmd').click();
    // }
    if (this.exportedData.length == 4) {
      this.toolReportName = 'List of Maps Report';
    }
  }

  getAttributeDesc(attribute: any) {
    if (this.model.listOfAttributes.length > 0) {
      var index = this.model.listOfAttributes.find((attr: any) => attr.symbol == attribute.symbol)
      if (index) {
        // console.log("index.description",index.description);
        return index.description;
      } else {
        return '';
      }
    } else {
      return '';
    }
  }

  getSpecifiedAttribute(attribute: any) {
    if (this.model.listOfAttributes.length > 0) {
      var index = this.model.listOfAttributes.find((attr: any) => attr.symbol == attribute.symbol)
      if (index) {
        // console.log("index.description",index.description);
        return index;
      } else {
        return '';
      }
    } else {
      return '';
    }
  }

  //To print display window
  printWindow() {
    window.print();
  }
  //To generate content list for the records
  generateContentlist(array: any, tool: any) {
    // console.log('generateContentlist array', array);
    // console.log('generateContentlist tool', tool);
    // /#!/export#
    if (this.exportedData.length == 4) {
      var html = '<h5><b>' + tool + '</b></h5>';
    } else {
      var html = '<h5><b>Table of contents</b></h5>';
    }
    $('#contentlist').append(html);
    var count = 0;
    for (var k = 0; k < array.length; k++) {
      if (tool == 'Deepdive') {
        //   html = '<a   class="list-group-item">' + (k + 1) + '. ' + array[k] + '</a>';
        // } else if (tool == 'InteractionMapper') {
        //   html = '<a href="/#!/export#' + array[k].eName + '" class="list-group-item">' + (k + 1) + '. ' + array[k].eName + '</a>';
        // } else if (tool == 'ScopeMapper') {
        //   html = '<a href="/#!/export#' + array[k].aType + '" class="list-group-item">' + (k + 1) + '. ' + array[k].aType + '</a>';
        // } else if (tool == 'Deepdive') {
        // if (scenarioEntities.indexOf(array[k].eType) > -1) {
        count++;
        // this.matchedEntity = model.listOfEUTs.find(eut => eut.eID == array[k].eID);
        // if (this.matchedEntity) {
        // href="' + appConst.redirectHostAddress + 'export#'
        html =
          '<a  class="list-group-item">' +
          count +
          '. ' +
          array[k].eName +
          '</a>';
        // } href="/#!/export#' + array[k].eID + '"
        $('#contentlist').append(html);
        // }
      } else if (tool == 'suites') {
        // href="/#!/export#' + array[k].suiteName + '"
        html =
          '<a  class="list-group-item">' +
          (k + 1) +
          '. ' +
          array[k].suiteName +
          '</a>';
        $('#contentlist').append(html);
      } else if (tool == 'Landscape') {
        if (array[k] == 'Environments') {
          //
          html =
            '<b><a href="/exportReport#' + array[k] + '"class="list-group-item">' +
            (k + 1) +
            '. Environment details</a></b>';
        } else if (array[k] == 'Summary') {
          html =
            '<b><a href="/exportReport#' + array[k] + '" class="list-group-item">' +
            (k + 1) +
            '. ' +
            array[k] +
            '</a></b>';
        } else {
          html =
            '<b><a href="/exportReport#' + array[k] + '" class="list-group-item">' +
            (k + 1) +
            '. List of ' +
            array[k] +
            '</a></b>';
        }

        $('#contentlist').append(html);
      } else if (tool == 'Persona Mapper') {
        if (array[k] == 'Summary') {
          html =
            '<b><a href="/exportReport#' + array[k] + '"  class="list-group-item">' +
            (k + 1) +
            '. ' +
            array[k] +
            '</a></b>';
        } else {
          html =
            '<b><a href="/exportReport#' + array[k] + '"  class="list-group-item">' +
            (k + 1) +
            '. Requirements used by [ ' +
            array[k] +
            ' ]</a></b>';
        }
        $('#contentlist').append(html);
      } else if (tool == 'Interaction Mapper') {
        if (array[k] == 'Summary') {
          html =
            '<b><a href="/exportReport#' + array[k] + '"  class="list-group-item">' +
            (k + 1) +
            '. ' +
            array[k] +
            '</a></b>';
        } else {
          html =
            '<b><a href="/exportReport#' + array[k] + '"  class="list-group-item">' +
            (k + 1) +
            '. ' +
            array[k] +
            ' Interaction Map</a></b>';
        }
        $('#contentlist').append(html);
      } else if (tool == 'Scope Mapper') {
        if (array[k] == 'Summary') {
          html =
            '<b><a  href="/exportReport#' + array[k] + '" class="list-group-item">' +
            (k + 1) +
            '. ' +
            array[k] +
            '</a></b>';
        } else {
          html =
            '<b><a href="/exportReport#' + array[k] + '"  class="list-group-item">' +
            (k + 1) +
            '. ' +
            array[k] +
            '</a></b>';
        }
        $('#contentlist').append(html);
      } else if (tool == 'Environment Mapper') {
        if (array[k] == 'Summary') {
          html =
            '<b><a href="/exportReport#' + array[k] + '"  class="list-group-item">' +
            (k + 1) +
            '. ' +
            array[k] +
            '</a></b>';
        } else {
          html =
            '<b><a  href="/exportReport#' + array[k] + '" class="list-group-item">' +
            (k + 1) +
            '. ' +
            array[k] +
            ' environment details</a></b>';
        }
        $('#contentlist').append(html);
      } else if (tool == 'Executor') {
        if (array[k].title == 'Summary') {
          // href="/#!/export#' + array[k].title + '"
          html =
            '<b><a href="/exportReport#' + array[k].title + '" class="list-group-item">' +
            (k + 1) +
            '. ' +
            array[k].title +
            '</a></b>';
          // html += '<ul>'
          for (var j = 0; j < array[k].sub.length; j++) {
            // href="/#!/export#' + array[k].sub[j] + '"
            html +=
              '<b><a  class="list-group-item">&nbsp;&nbsp;&nbsp;' +
              (k + 1) +
              '.' +
              (j + 1) +
              ' ' +
              array[k].sub[j] +
              '</a></b>';
          }
          // html += '</ul>'
        } else {
          // href="/#!/export#' + array[k].title + '"
          html =
            '<b><a href="/exportReport#' + array[k].title + '" class="list-group-item">' +
            (k + 1) +
            '. ' +
            array[k].title +
            '</a></b>';
        }
        $('#contentlist').append(html);
      } else {
        html =
          '<b><a href="/exportReport#' + array[k] + '"  class="list-group-item">' +
          (k + 1) +
          '. ' +
          array[k] +
          '</a></b>';
        $('#contentlist').append(html);
      }
    }
  }

  //To generate Interaction Header for the records
  generateInteractionHeader(
    index: any,
    header: any,
    tfArray: any,
    urArray: any,
    bfArray: any
  ) {
    var html = '<hr class="mt-0 mb-0" style="border-top: 1px solid black;" >';
    html += '<div class="row strict" id="' + header + '" >';
    html += '<h5>Section ' + index + ' : ' + header + '</h5>';
    html += '</div>';
    if (tfArray.length > 0) {
      html += '<div>interacts with (TF) : ';
      for (var c = 0; c < tfArray.length; c++) {
        if (c == tfArray.length - 1) {
          html += tfArray[c];
        } else {
          html += tfArray[c] + ' ,';
        }
      }
      html += '</div>';
    }
    if (tfArray.length == 0 && urArray.length > 0) {
      html += '<div>interacts with (UR) : ';
      for (var c = 0; c < urArray.length; c++) {
        if (c == urArray.length - 1) {
          html += urArray[c];
        } else {
          html += urArray[c] + ' ,';
        }
      }
      html += '</div>';
    } else if (urArray.length > 0) {
      html += '<div>is part of (UR) : ';
      for (var c = 0; c < urArray.length; c++) {
        if (c == urArray.length - 1) {
          html += urArray[c];
        } else {
          html += urArray[c] + ' ,';
        }
      }
      html += '</div>';
    }
    if (tfArray.length == 0 && urArray.length == 0 && bfArray.length > 0) {
      html += '<div>interacts with (BF) : ';
      for (var c = 0; c < bfArray.length; c++) {
        if (c == bfArray.length - 1) {
          html += bfArray[c];
        } else {
          html += bfArray[c] + ' ,';
        }
      }
      html += '</div>';
    } else if (bfArray.length > 0) {
      html += '<div>is part of (BF) : ';
      for (var c = 0; c < bfArray.length; c++) {
        if (c == bfArray.length - 1) {
          html += bfArray[c];
        } else {
          html += bfArray[c] + ' ,';
        }
      }
      html += '</div>';
    }
    $('#exportSheet').append(html);
  }

  //To generate Summary table for Landscape
  generateLandscapeSummaryTable() {
    var html = '<div class="row table-responsive-md">';
    // html += '<table class="toolReportSummaryTable >';
    html += '<div class="col-md-2">';
    html +=
      '<table class="table table-bordered mb-3"><thead><tr><th class="w-60">Title</th><th class="w-20  ">Total</th></tr></thead><tbody>';
    html +=
      '<tr><td class="pl-1">#Modules</td><td class="textalignright pr-1">' +
      this.model.modules.length +
      '</td></tr>';
    html +=
      '<tr><td class="pl-1">#Persona</td><td class="textalignright pr-1">' +
      this.model.persona.length +
      '</td></tr>';
    html +=
      '<tr><td class="pl-1">#Features</td><td class="textalignright pr-1">' +
      this.featureArray.length +
      '</td></tr>';
    html +=
      '<tr><td class="pl-1">#Requirements</td><td class="textalignright pr-1">' +
      this.requirementArray.length +
      '</td></tr>';
    html +=
      '<tr><td class="pl-1">#Flows</td><td class="textalignright pr-1">' +
      this.flowArray.length +
      '</td></tr>';
    html +=
      '<tr><td class="pl-1">#Unspecified</td><td class="textalignright pr-1">' +
      this.unspecifiedArray.length +
      '</td></tr>';
    html +=
      '<tr><td class="pl-1">#Attributes</td><td class="textalignright pr-1">' +
      this.DetailAttribute.length +
      '</td></tr>';
    html += '</tbody></table></div>';
    html += '<div class="col-md-6"></div>';
    html += '<div class="col-md-4"></div>';
    html += '</div>';
    $('#exportSheet').append(html);
  }
  //To generate table for Persona Mapper
  generatePersonaMapperTable() {
    var html = '<div class="row table-responsive-md">';
    // html += '<table class="landscaperSummaryTable toolReportSummaryTable">';
    // html += '<thead><th class="w-75">Persona</th><th>mapped to #UR</th></thead>'
    html += '<div class="col-md-2">';

    html +=
      '<table class="table table-bordered mb-3"><thead><tr><th >Persona</th><th Total>mapped to UR</th></tr></thead><tbody>';
    let entitiesNotMappedArray = [];
    for (var i = 0; i < this.model.persona.length; i++) {
      let personaMatchedArray = [];
      for (var j = 0; j < this.model.personaMap.length; j++) {
        if (this.model.persona[i].pType == this.model.personaMap[j].pType) {
          this.matchedEntity = this.model.listOfEUTs.find(
            (eut: any) => eut.eID == this.model.personaMap[j].eID
          );
          if (this.matchedEntity) {
            if (this.matchedEntity.eType == 'UR') {
              personaMatchedArray.push(this.matchedEntity.eName);
            }
          }
        }
      }
      if (personaMatchedArray.length > 0) {
        html +=
          '<tr><td>' +
          this.model.persona[i].pName +
          '</td><td class="textalignright pr-1">' +
          personaMatchedArray.length +
          '</td></tr>';
      }
    }
    html += '</tbody></table></div>';
    html += '<div class="col-md-6"></div>';
    html += '<div class="col-md-4"></div>';
    html += '</div>';
    $('#exportSheet').append(html);
  }
  //To generate Summary table for Persona Mapper
  generatePersonaMapperSummaryTable() {
    var html = '<div class="row table-responsive-md">';
    // html += '<table class="landscaperSummaryTable toolReportSummaryTable">';
    // html += '<thead><th class="w-75">Persona</th><th>mapped to #UR</th></thead>'
    html += '<div class="col-md-4">';
    html +=
      '<table class="table table-bordered mb-3"><thead><tr><th >Persona</th><th>Mapped to user requirements</th></tr></thead><tbody>';
    let entitiesNotMappedArray = [];
    for (var i = 0; i < this.model.persona.length; i++) {
      let personaMatchedArray = [];
      for (var j = 0; j < this.model.personaMap.length; j++) {
        if (this.model.persona[i].pType == this.model.personaMap[j].pType) {
          this.matchedEntity = this.model.listOfEUTs.find(
            (eut: any) => eut.eID == this.model.personaMap[j].eID
          );
          if (this.matchedEntity) {
            if (this.matchedEntity.eType == 'UR') {
              personaMatchedArray.push(this.matchedEntity.eName);
            }
          }
        }
      }
      if (personaMatchedArray.length > 0) {
        html +=
          '<tr><td>' +
          this.model.persona[i].pName +
          '</td><td class="textalignright pr-1">' +
          personaMatchedArray.length +
          '</td></tr>';
      }
    }
    html += '</tbody></table>';

    for (var k = 0; k < this.model.listOfEUTs.length; k++) {
      this.matchedEntity = this.model.personaMap.find(
        (eut: any) => eut.eID == this.model.listOfEUTs[k].eID
      );
      if (!this.matchedEntity) {
        if (this.model.listOfEUTs[k].eType == 'UR') {
          entitiesNotMappedArray.push(this.model.listOfEUTs[k]);
        }
      }
    }
    if (entitiesNotMappedArray.length > 0) {
      html +=
        '<h6>(' +
        entitiesNotMappedArray.length +
        ') requirements are NOT mapped to any personas at all.</h6>';
      html += '<ol>';
      for (var l = 0; l < entitiesNotMappedArray.length; l++) {
        html += '<li>' + this.getModuleName(entitiesNotMappedArray[l]) + ' | ' + entitiesNotMappedArray[l].eName + '</li>';
      }
      html += '</ol>';
    }
    html += '</><div class="col-md-4"></div>';
    html += '<div class="col-md-4"></div>';
    $('#exportSheet').append(html);
  }

  generateInteractionMapperTable() {
    var eutTypesInteraction = ['TF', 'UR', 'BF', 'XX'];
    var html = '<div class="row table-responsive-md">';
    html +=
      '<b></b><h6>Interaction Mapper Table</h6></b>';
    html += '<div class="col-md-4">';
    html +=
      '<table class="table table-bordered mb-3"><thead><tr><th class="w-60" >Entity types</th><th Total>TF</th><th Total>UR</th><th Total>BF</th><th Total>XX</th></tr></thead><tbody>';
    for (var i = 0; i < eutTypesInteraction.length; i++) {
      var total = 0;
      var totalTF = 0;
      var totalUR = 0;
      var totalBF = 0;
      var totalXX = 0;
      for (var j = 0; j < this.model.listOfEUTs.length; j++) {
        if (eutTypesInteraction[i] == this.model.listOfEUTs[j].eType) {
          for (var k = 0; k < this.model.interactionMap.length; k++) {
            if (
              this.model.listOfEUTs[j].eID ==
              this.model.interactionMap[k].eut1
            ) {
              this.matchedEntity = this.model.listOfEUTs.find(
                (eut: any) => eut.eID == this.model.interactionMap[k].eut2
              );
              if (this.matchedEntity) {
                total++;
                if (this.matchedEntity.eType == 'TF') {
                  totalTF++;
                } else if (this.matchedEntity.eType == 'UR') {
                  totalUR++;
                } else if (this.matchedEntity.eType == 'BF') {
                  totalBF++;
                }
                else if (this.matchedEntity.eType == 'XX') {
                  totalXX++;
                }
              }
            }
          }
        }
      }
      var eutType = '';
      if (eutTypesInteraction[i] == 'TF') {
        eutType = 'Technical features';
      }
      if (eutTypesInteraction[i] == 'UR') {
        eutType = 'Requirements features';
      }
      if (eutTypesInteraction[i] == 'BF') {
        eutType = 'Business flows';
      }
      if (eutTypesInteraction[i] == 'XX') {
        eutType = 'Unspecified';
      }
      html +=
        '<tr><td>' +
        eutType +
        ' (' +
        total +
        ')</td><td class="textalignright pr-1">' +
        totalTF +
        '</td><td class="textalignright pr-1">' +
        totalUR +
        '</td><td class="textalignright pr-1">' +
        totalBF +
        '</td><td class="textalignright pr-1">' +
        totalXX +
        '</td></tr>';
    }
    html += '</tbody></table>';
    html += '</div>';
    html += '<div class="col-md-4"></div>';
    html += '<div class="col-md-4"></div>';
    html += '</div>';
    $('#exportSheet').append(html);
  }
  generateScopeMapperTable() {
    this.mappedAttributesWithEUTs = [];
    var html = '<div class="row table-responsive-md">';
    html += '<div class="col-md-4">';
    html +=
      '<table class="table table-bordered mb-3"><thead><tr><th class="w-40">Attribute</th><th Total>TF</th><th Total>UR</th><th Total>BF</th><th Total>XX</th></tr></thead><tbody>';
    for (var i = 0; i < this.Config.listOfAttributesUpdated.length; i++) {
      var attributeSymbol = this.Config.listOfAttributesUpdated[i].symbol;
      // var attributeSymbol = str[1].slice(0, 2);
      let personafeatureArray = [];
      let personarequirementArray = [];
      let personaflowArray = [];
      let personaunspecArray = [];
      for (var j = 0; j < this.model.scopeMap.length; j++) {
        if (attributeSymbol == this.model.scopeMap[j].aType) {
          this.matchedEntity = this.model.listOfEUTs.find(
            (eut: any) => eut.eID == this.model.scopeMap[j].eID
          );
          if (this.matchedEntity) {
            if (this.selectedEntities.indexOf('TF') > -1) {
              if (this.matchedEntity.eType == 'TF') {
                personafeatureArray.push(this.matchedEntity.eName);
              }
            }
            if (this.selectedEntities.indexOf('UR') > -1) {
              if (this.matchedEntity.eType == 'UR') {
                personarequirementArray.push(this.matchedEntity.eName);
              }
            }
            if (this.selectedEntities.indexOf('BF') > -1) {
              if (this.matchedEntity.eType == 'BF') {
                personaflowArray.push(this.matchedEntity.eName);
              }
            }
            if (this.selectedEntities.indexOf('XX') > -1) {
              if (this.matchedEntity.eType == 'XX') {
                personaunspecArray.push(this.matchedEntity.eName);
              }
            }
          }
        }
      }
      if (
        personafeatureArray.length > 0 ||
        personarequirementArray.length > 0 ||
        personaflowArray.length > 0 ||
        personaunspecArray.length > 0
      ) {
        html +=
          '<tr><td>' +
          this.Config.listOfAttributesUpdated[i].name + ' (' + this.Config.listOfAttributesUpdated[i].symbol +
          ')</td><td class="textalignright pr-1">' +
          personafeatureArray.length +
          '</td><td class="textalignright pr-1">' +
          personarequirementArray.length +
          '</td><td class="textalignright pr-1">' +
          personaflowArray.length +
          '</td><td class="textalignright pr-1">' +
          personaunspecArray.length +
          '</td></tr>';
        this.mappedAttributesWithEUTs.push(
          this.Config.listOfAttributesUpdated[i].symbol
        );
      }
    }
    html += '</tbody></table></div>';
    html += '<div class="col-md-4"></div>';
    html += '<div class="col-md-4"></div>';
    html += '</div>';
    $('#exportSheet').append(html);
  }
  generateScopeMapperSummary() {
    this.mappedAttributesWithEUTs = [];
    var html1 = '<div class="row table-responsive-md">';
    // var html1 = '<div class="col-md-6">';
    html1 +=
      '<table class="table table-bordered mb-3"><thead><tr><th >Attribute</th><th Total>Technical features</th><th Total>User requirements</th><th Total>Business flows</th><th Total>Unspecified</th></tr></thead><tbody>';
    for (var i = 0; i < this.Config.listOfAttributesUpdated.length; i++) {
      var attributeSymbol = this.Config.listOfAttributesUpdated[i].symbol;
      // var attributeSymbol = str[1].slice(0, 2);
      let personafeatureArray = [];
      let personarequirementArray = [];
      let personaflowArray = [];
      let personaunspecArray = [];
      for (var j = 0; j < this.model.scopeMap.length; j++) {
        if (attributeSymbol == this.model.scopeMap[j].aType) {
          this.matchedEntity = this.model.listOfEUTs.find(
            (eut: any) => eut.eID == this.model.scopeMap[j].eID
          );
          if (this.matchedEntity) {
            if (this.selectedEntities.indexOf('TF') > -1) {
              if (this.matchedEntity.eType == 'TF') {
                personafeatureArray.push(this.matchedEntity.eName);
              }
            }
            if (this.selectedEntities.indexOf('UR') > -1) {
              if (this.matchedEntity.eType == 'UR') {
                personarequirementArray.push(this.matchedEntity.eName);
              }
            }
            if (this.selectedEntities.indexOf('BF') > -1) {
              if (this.matchedEntity.eType == 'BF') {
                personaflowArray.push(this.matchedEntity.eName);
              }
            }
            if (this.selectedEntities.indexOf('XX') > -1) {
              if (this.matchedEntity.eType == 'XX') {
                personaunspecArray.push(this.matchedEntity.eName);
              }
            }
          }
        }
      }
      // console.log("personafeatureArray",personafeatureArray);
      // console.log("personarequirementArray",personarequirementArray);
      // console.log("personaflowArray",personaflowArray);
      // console.log("personaunspecArray",personaunspecArray);
      if (
        personafeatureArray.length > 0 ||
        personarequirementArray.length > 0 ||
        personaflowArray.length > 0 ||
        personaunspecArray.length > 0
      ) {
        html1 +=
          '<tr><td>' +
          this.Config.listOfAttributesUpdated[i].name + ' (' + this.Config.listOfAttributesUpdated[i].symbol +
          ')</td><td class="textalignright pr-1">' +
          personafeatureArray.length +
          '</td><td class="textalignright pr-1">' +
          personarequirementArray.length +
          '</td><td class="textalignright pr-1">' +
          personaflowArray.length +
          '</td><td class="textalignright pr-1">' +
          personaunspecArray.length +
          '</td></tr>';
        this.mappedAttributesWithEUTs.push(
          this.Config.listOfAttributesUpdated[i].symbol
        );
      }
    }
    html1 += '</tbody></table>';
    let entitiesTFNotMappedArray = [];
    let entitiesURNotMappedArray = [];
    let entitiesBFNotMappedArray = [];
    let entitiesXXNotMappedArray = [];
    let countTF = 0;
    let countUR = 0;
    let countBF = 0;
    let countXX = 0;
    let notMappedTFStatus = 0;
    let notMappedURStatus = 0;
    let notMappedBFStatus = 0;
    let notMappedXXStatus = 0;
    for (var k = 0; k < this.model.listOfEUTs.length; k++) {
      this.matchedEntity = this.model.scopeMap.find(
        (eut: any) => eut.eID == this.model.listOfEUTs[k].eID
      );
      if (!this.matchedEntity) {
        if (this.model.listOfEUTs[k].eType == 'TF') {
          entitiesTFNotMappedArray.push(this.model.listOfEUTs[k].eName);
        }
        if (this.model.listOfEUTs[k].eType == 'UR') {
          entitiesURNotMappedArray.push(this.model.listOfEUTs[k].eName);
        }
        if (this.model.listOfEUTs[k].eType == 'BF') {
          entitiesBFNotMappedArray.push(this.model.listOfEUTs[k].eName);
        }
        if (this.model.listOfEUTs[k].eType == 'XX') {
          entitiesXXNotMappedArray.push(this.model.listOfEUTs[k].eName);
        }
      }
      if (this.model.listOfEUTs[k].eType == 'TF') {
        countTF++;
      } else if (this.model.listOfEUTs[k].eType == 'UR') {
        countUR++;
      } else if (this.model.listOfEUTs[k].eType == 'BF') {
        countBF++;
      } else if (this.model.listOfEUTs[k].eType == 'XX') {
        countXX++;
      }
    }
    // console.log("mappedTF", entitiesTFNotMappedArray);
    // console.log("mappedUR", entitiesURNotMappedArray);
    // console.log("mappedBF", entitiesBFNotMappedArray);

    // console.log("countTF", countTF);
    // console.log("countUR", countUR);
    // console.log("countBF", countBF);
    var html =
      '<p>(' +
      this.mappedAttributesWithEUTs.length +
      ') attributes have been mapped to entities, details are:</p>';
    html += html1;
    if (entitiesTFNotMappedArray.length > 0) {
      notMappedTFStatus = Math.round(
        (entitiesTFNotMappedArray.length / countTF) * 100
      );
      html +=
        '<h6>(' +
        notMappedTFStatus +
        '% i.e ' +
        entitiesTFNotMappedArray.length +
        '/' +
        countTF +
        ' ) of features are unmapped.</h6>';
    }
    if (entitiesURNotMappedArray.length > 0) {
      notMappedURStatus = Math.round(
        (entitiesURNotMappedArray.length / countUR) * 100
      );
      html +=
        '<h6>(' +
        notMappedURStatus +
        '% i.e ' +
        entitiesURNotMappedArray.length +
        '/' +
        countUR +
        ' ) of requirements are unmapped.</h6>';
    }
    if (entitiesBFNotMappedArray.length > 0) {
      notMappedBFStatus = Math.round(
        (entitiesBFNotMappedArray.length / countBF) * 100
      );
      html +=
        '<h6>(' +
        notMappedBFStatus +
        '% i.e ' +
        entitiesBFNotMappedArray.length +
        '/' +
        countBF +
        ' ) of flows are unmapped.</h6>';
    }
    if (entitiesXXNotMappedArray.length > 0) {
      notMappedXXStatus = Math.round(
        (entitiesBFNotMappedArray.length / countXX) * 100
      );
      html +=
        '<h6>(' +
        notMappedXXStatus +
        '% i.e ' +
        entitiesXXNotMappedArray.length +
        '/' +
        countXX +
        ' ) of unspecified are unmapped.</h6>';
    }


    $('#exportSheet').append(html);
  }

  generateEnvironmentSummary() {
    var html = '';
    if (this.model.envMap.length > 0) {
      html =
        '<h6>There are (' +
        this.model.envMap.length +
        ') environments and these are:</h6>';
      html += '<ol>';
      for (var i = 0; i < this.model.envMap.length; i++) {
        html += '<li>' + this.model.envMap[i].envName + '</li>';
      }
      html += '</ol>';
    }
    $('#exportSheet').append(html);
  }
  //To generate Header for the records
  generateSuiteEntityHeader(index: any, header: any) {
    var html = '<div class="row strict" id="' + header + '" >';
    html += '<h5><b>' + header.eType + '  : (' + header.eName + ')</b></h5>';
    html += '</div>';
    $('#exportSheet').append(html);
  }
  //To generate Header for the records
  generateHeader(index: any, header: any) {
    var html = '<hr class="mt-0 mb-0" style="border-top: 1px solid black;" >';
    html += '<div class="row strict" id="' + header + '" >';
    if (header == 'Environments') {
      html += '<h5><b>Section   ' + index + '  : Environment details</b></h5>';
    } else if (
      header == 'Modules' ||
      header == 'Persona' ||
      header == 'Features' ||
      header == 'Requirements' ||
      header == 'Flows' ||
      header == 'Unspecified' ||
      header == 'Attributes'
    ) {
      html +=
        '<h5><b>Section   ' + index + '  : List of ' + header + '</b></h5>';
    } else {
      html += '<h5><b>Section   ' + index + '  : ' + header + '</b></h5>';
    }
    html += '</div>';
    $('#exportSheet').append(html);
  }

  //To generate Header for the records
  generateMapperSectionHeader(index: any, header: any, type: any) {
    var html = '<hr class="mt-0 mb-0" style="border-top: 1px solid black;" >';
    html += '<div class="row strict" id="' + header + '" >';
    if (type == 'Summary') {
      html += '<h5>Section   ' + index + '  : ' + header + '</h5>';
    } else if (type == 'Persona') {
      html +=
        '<h5>Section   ' +
        index +
        '  : Requirements used by [ ' +
        header +
        ' ] </h5>';
    } else if (type == 'Scope') {
      html += '<h5>Section   ' + index + '  : ' + header + '</h5>';
    } else if (type == 'Env') {
      html +=
        '<h5>Section   ' +
        index +
        '  : ' +
        header +
        ' environment details</h5>';
    }
    html += '</div>';
    $('#exportSheet').append(html);
  }
  //To generate Subheader for the records
  generateMapperSectionSubheader(
    header: any,
    data: any,
    index: any,
    subindex: any,
    type: any,
    name: any
  ) {
    var html = '<div class="row strict">';
    if (type == 'Persona') {
      html +=
        '<h6>(' +
        data.length +
        ') requirements are used by [' +
        name +
        '], and these are:</h6>';
    } else if (type == 'Scope') {
      var desc = '';
      if (header == 'Features') {
        desc = 'Technical feature(s)';
      } else if (header == 'Requirements') {
        desc = 'User Requirement(s)';
      } else if (header == 'Flows') {
        desc = 'Business flow(s)';
      } else if (header == 'Unspecified') {
        desc = 'Unspecified(s)';
      }
      html +=
        '<h6>(' +
        index +
        '.' +
        subindex +
        ') ' +
        desc +
        ' mapped to this attribute are:</h6>';
    }
    // html += '<h6>They are :</h6>'
    // html += '<h6>' + appConst.exportReportContent.SubHeaderTitle + ' ' + header + ' are : </h6>';
    html += '</div>';
    $('#exportSheet').append(html);
  }

  //To generate Subheader for the records
  generateSubheader(header: any, data: any) {
    var headerType = '';
    if (header == 'Persona') {
      headerType = 'end user types';
    } else if (header == 'Specified Attributes') {
      headerType = 'stated attributes';
    } else if (header == 'Modules') {
      headerType = 'Modules';
    } else if (header == 'Features') {
      headerType = 'Technical Features';
    } else if (header == 'Requirements') {
      headerType = 'User Requirements';
    } else if (header == 'Flows') {
      headerType = 'Business Flows';
    } else if (header == 'Unspecified') {
      headerType = 'Unspecified';
    }
    var html = '<div >';
    if (header == 'Not-Specified Attributes') {
      html +=
        '<h6> Note that these (' +
        data.length +
        ') attributes have <b>NOT</b> been specified.';
    } else if (header == 'Environments') {
      html +=
        '<h6> The environment is constituted by (' +
        data.length +
        ') environment types and these are:</h6>';
    } else {
      html +=
        '<h6> There are (' +
        data.length +
        ') ' +
        headerType +
        ' and these are:</h6>';
    }
    // html += '<h6>They are :</h6>'
    html += '</div>';
    $('#exportSheet').append(html);
  }

  //To generate Notes for the records
  generateNotesSublist(note: any, type: any, index: any) {
    var html = '<div class="row">';
    html +=
      '<div class="exportsubheaderFontSize">' +
      note +
      ', Note Type : ' +
      type +
      '</div>';
    html += '</div>';
    $('#exportSheet').append(html);
  }
  //To generate Scenario header for the records
  generateScenarioheader(headerIndex: any, entityArray: any) {
    for (var j = 0; j < entityArray.length; j++) {
      var htmlHeader =
        '<div class="exportsubheaderFontSize"><b> Entity : ' +
        entityArray[j].name +
        ' </b></div>';
      if (entityArray[j].scenarios.length > 0) {
        $('#exportSheet').append(htmlHeader);
      }
      for (var i = 0; i < entityArray[j].scenarios.length; i++) {
        // html = '<div class="row">';
        // html += '<h3 class="exportsubTextFontSize">' + headerIndex + '.' + entityArray[j].scenarios[i].index + ': ' + entityArray[j].scenarios[i].description + ' </h5>';
        // html += '<p> (' + entityArray[j].scenarios[i].cr + ',' + entityArray[j].scenarios[i].priority + ')</p>';
        // html += '</div>';
        // $("#exportSheet").append(html);
        var res = entityArray[j].scenarios[i].priority.substr(0, 1);
        this.generateScenarioList(
          headerIndex,
          entityArray[j].scenarios[i].index,
          entityArray[j].scenarios[i].description,
          entityArray[j].scenarios[i].cr,
          entityArray[j].scenarios[i].eID,
          res
        );
      }
    }
  }

  //To genater sublist key and its value
  generateScenarioList(
    headerIndex: any,
    subIndex: any,
    description: any,
    cr: any,
    eID: any,
    priority: any
  ) {
    // html = '<div class="row">';
    var html =
      '<h3 class="exportsubTextFontSize">' +
      subIndex +
      ' : ' +
      this.getModuleNameByeID(eID) + ' | ' +
      description +
      ' </h5>';
    // (' + cr + ',' + priority + ')
    // html += '<p> (' + cr + ',' + priority + ')</p>';
    // html += '</div>';
    $('#exportSheet').append(html);
  }

  //To generate dynamical list of records
  generateList(data: any, header: any) {
    // console.log("data",data,header);
    var html = '<div><ol>';
    for (var i = 0; i < data.length; i++) {
      if (header == 'Persona') {
        html += '<li>' + data[i].pName + '</li>';
      } else if (header == 'Modules') {
        html += '<li>' + data[i].mName + '</li>';
      } else if (header == 'Attributes') {
        html += '<li>' + data[i].name + ' (' + data[i].symbol + ') : ' + data[i].description + '</li>';
      } else if (header == 'NonAttributes') {
        html += '<li>' + data[i].name + ' (' + data[i].symbol + ')</li>';
      } else if (
        header == 'Requirements' ||
        header == 'Flows' ||
        header == 'Unspecified' ||
        header == 'Features'
      ) {
        html += '<li>' + this.getModuleName(data[i]) + ' | ' + data[i].eName + '</li>';
      } else if (header == 'Environment') {
        html += '<li>' + data[i] + '</li>';
      } else {
        html += '<li>' + this.getModuleName(data[i]) + ' | ' + data[i].eName + '</li>';
      }
    }
    html += '</ol><div>';
    $('#exportSheet').append(html);
  }

  //To generate dynamical sublist of records
  generateSubList(data: any, header: any) {
    var html = '<ol>';
    for (var i = 0; i < data.length; i++) {
      html += '<li><h6>' + data[i].envType + ' : </h6></li>';
      html += '<ul>';
      let env = data[i].envValues;
      for (var j = 0; j < env.length; j++) {
        html += '<li>' + env[j] + '</li>';
      }
      html += '</ul>';
    }
    html += '</ol>';
    html += '</div>';
    $('#exportSheet').append(html);
  }

  //To generate Summary table for Scenarios
  generateSummaryTable(summaryArray: any) {
    var html = '<div class="row">';
    html += '<table class="exportTable"><thead>';
    html +=
      '<tr><th>TT</th><th>Entity Type</th><th>#EUT</th><th>#Scenarios</th><th>+Ve</th><th>-Ve</th></tr>';
    html += '</thead><tbody>';
    for (var i = 0; i < summaryArray.length; i++) {
      if (!summaryArray[i].positiveCount) {
        summaryArray[i].positiveCount = 0;
      }
      if (!summaryArray[i].negativeCount) {
        summaryArray[i].negativeCount = 0;
      }
      html += '<tr>';
      html +=
        '<td title="' +
        summaryArray[i].name +
        '">' +
        summaryArray[i].symbol +
        '</td>';
      html += '<td>' + summaryArray[i].eType + '</td>';
      html += '<td>' + summaryArray[i].eutCount + '</td>';
      html += '<td>' + summaryArray[i].scenarioCount + '</td>';
      html += '<td>' + summaryArray[i].positiveCount + '</td>';
      html += '<td>' + summaryArray[i].negativeCount + '</td>';
      html += '</tr>';
    }
    html += '</tbody></table>';
    $('#exportSheet').append(html);
  }

  //To generate Sections and sublist of records for Persona Mapper
  generatePersonaMapperSubList() {
    let personaTableContentArray = [];
    var indexVal = 1;
    this.generateMapperSectionHeader(indexVal, 'Summary', 'Summary');
    this.generatePersonaMapperSummaryTable();
    for (var i = 0; i < this.model.persona.length; i++) {
      let personafeatureArray = [];
      let personarequirementArray = [];
      let personaflowArray = [];
      let sublistIndex = 1;
      let sublistSubIndex = 0;
      for (var j = 0; j < this.model.personaMap.length; j++) {
        if (this.model.persona[i].pType == this.model.personaMap[j].pType) {
          this.matchedEntity = this.model.listOfEUTs.find(
            (eut: any) => eut.eID == this.model.personaMap[j].eID
          );
          if (this.matchedEntity) {
            if (this.selectedEntities.indexOf('TF') > -1) {
              if (this.matchedEntity.eType == 'TF') {
                personafeatureArray.push(this.matchedEntity);
              }
            }
            if (this.selectedEntities.indexOf('UR') > -1) {
              if (this.matchedEntity.eType == 'UR') {
                personarequirementArray.push(this.matchedEntity);
              }
            }
            if (this.selectedEntities.indexOf('BF') > -1) {
              if (this.matchedEntity.eType == 'BF') {
                personaflowArray.push(this.matchedEntity);
              }
            }
          }
        }
      }
      if (personarequirementArray.length > 0) {
        indexVal = indexVal + 1;
        this.generateMapperSectionHeader(
          indexVal,
          this.model.persona[i].pName,
          'Persona'
        );
        personaTableContentArray.push(this.model.persona[i].pName);
      }
      // if (personafeatureArray.length > 0) {
      //   sublistSubIndex++;
      //   generateMapperSectionSubheader('Features', personafeatureArray, indexVal, sublistSubIndex);
      //   generateList(personafeatureArray, this.model.persona[i].pName);
      // }
      if (personarequirementArray.length > 0) {
        sublistSubIndex++;
        this.generateMapperSectionSubheader(
          'Requirements',
          personarequirementArray,
          indexVal,
          sublistSubIndex,
          'Persona',
          this.model.persona[i].pName
        );
        this.generateList(personarequirementArray, this.model.persona[i].pName);
      }
      // if (personaflowArray.length > 0) {
      //   sublistSubIndex++;
      //   generateMapperSectionSubheader('Flows', personaflowArray, indexVal, sublistSubIndex);
      //   generateList(personaflowArray, this.model.persona[i].pName);
      // }
    }
    if (personaTableContentArray.length != 0) {
      // if(exportedData.length != 4){
      personaTableContentArray.unshift('Summary');
      this.generateContentlist(personaTableContentArray, 'Persona Mapper');
      // }
    } else {
      var html = '<div class="row strict">';
      html +=
        '<div class="alert alert-warning"><strong><div style="text-align: center;">There is no persona to show. Go and add persona in Landscape & map in persona mapper tool.</div></strong></div>';
      html += '</div>';
      $('#exportSheet').append(html);
    }
  }

  //To generate Sections and sublist of records for Interaction Mapper
  generateInteractionMapperSubList() {
    // for (var i = 0; i < this.model.listOfEUTs.length; i++) {
    //   let personafeatureArray = [];
    //   let personarequirementArray = [];
    //   let personaflowArray = [];
    //   for (var j = 0; j < this.model.interactionMap.length; j++) {
    //     if (this.model.listOfEUTs[i].eID == this.model.interactionMap[j].eut1) {
    //       this.matchedEntity = this.model.listOfEUTs.find(eut => eut.eID == this.model.interactionMap[j].eut2);
    //       if (this.matchedEntity) {
    //         if (selectedEntities.indexOf("TF") > -1) {
    //           if (this.matchedEntity.eType == "TF") {
    //             personafeatureArray.push(this.matchedEntity.eName);
    //           }
    //         }
    //         if (selectedEntities.indexOf("UR") > -1) {
    //           if (this.matchedEntity.eType == "UR") {
    //             personarequirementArray.push(this.matchedEntity.eName);
    //           }
    //         }
    //         if (selectedEntities.indexOf("BF") > -1) {
    //           if (this.matchedEntity.eType == "BF") {
    //             personaflowArray.push(this.matchedEntity.eName);
    //           }
    //         }
    //       }
    //     }
    //   }

    //   if (personafeatureArray.length > 0 || personarequirementArray.length > 0
    //     || personaflowArray.length > 0) {
    //     indexVal = indexVal + 1;
    //     generateInteractionHeader(indexVal, this.model.listOfEUTs[i].eName, personafeatureArray, personarequirementArray, personaflowArray);
    //     interactionTableContentArray.push(this.model.listOfEUTs[i].eName);
    //   }
    // old code
    // if (personafeatureArray.length > 0 || personarequirementArray.length > 0 || personaflowArray.length > 0) {
    //   indexVal = indexVal + 1;
    //   generateHeader(indexVal, this.model.listOfEUTs[i].eName);
    // }
    // if (personafeatureArray.length > 0) {
    //   generateSubheader('Features',personafeatureArray);
    //   generateList(personafeatureArray, this.model.listOfEUTs[i].eName);
    // }
    // if (personarequirementArray.length > 0) {
    //   generateSubheader('Requirements',personarequirementArray);
    //   generateList(personarequirementArray, this.model.listOfEUTs[i].eName);
    // }
    // if (personaflowArray.length > 0) {
    //   generateSubheader('Flows',personaflowArray);
    //   generateList(personaflowArray, this.model.listOfEUTs[i].eName);
    // }
    // }
    if (this.model.interactionMap.length != 0) {
      let interactionTableContentArray = [
        'Summary',
        'Feature',
        'Requirement',
        'Flow',
        'Unspecified',
      ];
      this.generateContentlist(
        interactionTableContentArray,
        'Interaction Mapper'
      );
      var html = '<hr class="mt-0 mb-0" style="border-top: 1px solid black;" >';
      $('#exportSheet').append(html);
      var indexVal = 0;
      for (var i = 0; i < interactionTableContentArray.length; i++) {
        indexVal++;
        this.generateInteractionMapperData(
          indexVal,
          interactionTableContentArray[i]
        );
      }

      // generateMapperSectionHeader(indexVal, 'Summary', 'Summary');
      // generatePersonaMapperSummaryTable();
    } else {
      html = '<div class="row strict">';
      html +=
        '<div class="alert alert-warning"><strong><div style="text-align: center;">There is no records to show. Go and check interaction mapper.</div></strong></div>';
      html += '</div>';
      $('#exportSheet').append(html);
    }
  }

  generateInteractionMapperData(index: any, type: any) {
    var html = '<div class="row strict" id="' + type + '" >';
    if (type == 'Summary') {
      html += '<h5>Section   ' + index + '  : ' + type + '</h5>';
    } else {
      html += '<hr class="mt-0 mb-0" style="border-top: 1px solid black;" >';
      html +=
        '<h5>Section   ' + index + '  : ' + type + ' Interaction Map</h5>';
    }
    html += '</div>';
    $('#exportSheet').append(html);
    var eutTypesInteraction = ['TF', 'UR', 'BF', 'XX'];
    if (type == 'Summary') {
      html = '<div class="row table-responsive-md">';
      html += '<div class="col-md-6">';
      html +=
        '<table class="table table-bordered mb-3"><thead><tr><th >Entity types</th><th Total>Technical features</th><th Total>User requirements</th><th Total>Business flows</th><th Total>Unspecified</th></tr></thead><tbody>';
      for (var i = 0; i < eutTypesInteraction.length; i++) {
        var total = 0;
        var totalTF = 0;
        var totalUR = 0;
        var totalBF = 0;
        var totalXX = 0;
        for (var j = 0; j < this.model.listOfEUTs.length; j++) {
          if (eutTypesInteraction[i] == this.model.listOfEUTs[j].eType) {
            for (var k = 0; k < this.model.interactionMap.length; k++) {
              if (
                this.model.listOfEUTs[j].eID ==
                this.model.interactionMap[k].eut1
              ) {
                this.matchedEntity = this.model.listOfEUTs.find(
                  (eut: any) => eut.eID == this.model.interactionMap[k].eut2
                );
                if (this.matchedEntity) {
                  total++;
                  if (this.matchedEntity.eType == 'TF') {
                    totalTF++;
                  } else if (this.matchedEntity.eType == 'UR') {
                    totalUR++;
                  } else if (this.matchedEntity.eType == 'BF') {
                    totalBF++;
                  }
                  else if (this.matchedEntity.eType == 'XX') {
                    totalXX++;
                  }
                }
              }
            }
          }
        }
        var eutType = '';
        if (eutTypesInteraction[i] == 'TF') {
          eutType = 'Technical features';
        }
        if (eutTypesInteraction[i] == 'UR') {
          eutType = 'Requirements features';
        }
        if (eutTypesInteraction[i] == 'BF') {
          eutType = 'Business flows';
        }
        if (eutTypesInteraction[i] == 'XX') {
          eutType = 'Unspecified';
        }
        html +=
          '<tr><td>' +
          eutType +
          ' (' +
          total +
          ')</td><td class="textalignright pr-1">' +
          totalTF +
          '</td><td class="textalignright pr-1">' +
          totalUR +
          '</td><td class="textalignright pr-1">' +
          totalBF +
          '</td><td class="textalignright pr-1">' +
          totalXX +
          '</td></tr>';
      }
      html += '</tbody></table></div>';
      html += '<div class="col-md-6"></div>';
      html += '</div>';
      $('#exportSheet').append(html);
    } else {
      this.eTypeInteraction = '';
      if (type == 'Feature') {
        this.eTypeInteraction = 'TF';
      } else if (type == 'Requirement') {
        this.eTypeInteraction = 'UR';
      } else if (type == 'Flow') {
        this.eTypeInteraction = 'BF';
      } else if (type == 'Unspecified') {
        this.eTypeInteraction = 'XX';
      }
      var subIndex = 0;
      for (var j = 0; j < this.model.listOfEUTs.length; j++) {
        if (this.eTypeInteraction == this.model.listOfEUTs[j].eType) {
          html = '';
          subIndex++;
          var totalMapped = 0;
          var countTF = 0;
          var countUR = 0;
          var countBF = 0;
          var countXX = 0;
          html +=
            '<h6>' +
            index +
            '.' +
            subIndex +
            ' ' +
            this.model.listOfEUTs[j].eName +
            '</h6>';
          for (var k = 0; k < this.model.interactionMap.length; k++) {
            if (
              this.model.listOfEUTs[j].eID == this.model.interactionMap[k].eut1
            ) {
              this.matchedEntity = this.model.listOfEUTs.find(
                (eut: any) => eut.eID == this.model.interactionMap[k].eut2
              );
              if (this.matchedEntity) {
                totalMapped++;
                if (this.matchedEntity.eType == 'TF') {
                  countTF++;
                } else if (this.matchedEntity.eType == 'UR') {
                  countUR++;
                } else if (this.matchedEntity.eType == 'BF') {
                  countBF++;
                } else if (this.matchedEntity.eType == 'XX') {
                  countXX++;
                }
              }
            }
          }
          if (totalMapped != 0) {
            $('#exportSheet').append(html);
          }
          var header1 = 'interacts with';
          var header2 = 'interacts with';
          var header3 = 'interacts with';
          var header4 = 'interacts with';
          if (this.eTypeInteraction == 'TF') {
            header2 = 'used by';
            header3 = 'used by';
          } else if (this.eTypeInteraction == 'UR') {
            header3 = 'used by';
          }
          var htmlTF = '<h6>' + header1 + ' TF(' + countTF + ')</h6>';
          var htmlUR = '<h6>' + header2 + ' UR(' + countUR + ')</h6>';
          var htmlBF = '<h6>' + header3 + ' BF(' + countBF + ')</h6>';
          var htmlXX = '<h6>' + header4 + ' XX(' + countXX + ')</h6>';
          for (var k = 0; k < this.model.interactionMap.length; k++) {
            if (
              this.model.listOfEUTs[j].eID == this.model.interactionMap[k].eut1
            ) {
              this.matchedEntity = this.model.listOfEUTs.find(
                (eut: any) => eut.eID == this.model.interactionMap[k].eut2
              );
              if (this.matchedEntity) {
                // console.log("this.matchedEntity", this.matchedEntity);
                if (this.matchedEntity.eType == 'TF') {
                  // countTF++;
                  htmlTF += '<p>- ' + this.getModuleName(this.matchedEntity) + ' | ' + this.matchedEntity.eName + '</p>';
                } else if (this.matchedEntity.eType == 'UR') {
                  // countUR++;
                  htmlUR += '<p>- ' + this.getModuleName(this.matchedEntity) + ' | ' + this.matchedEntity.eName + '</p>';
                } else if (this.matchedEntity.eType == 'BF') {
                  // countBF++;
                  htmlBF += '<p>- ' + this.getModuleName(this.matchedEntity) + ' | ' + this.matchedEntity.eName + '</p>';
                } else if (this.matchedEntity.eType == 'XX') {
                  // countBF++;
                  htmlXX += '<p>- ' + this.getModuleName(this.matchedEntity) + ' | ' + this.matchedEntity.eName + '</p>';
                }
              }
            }
          }
          if (countTF != 0) {
            $('#exportSheet').append(htmlTF);
          }
          if (countUR != 0) {
            $('#exportSheet').append(htmlUR);
          }
          if (countBF != 0) {
            $('#exportSheet').append(htmlBF);
          }
          if (countXX != 0) {
            $('#exportSheet').append(htmlXX);
          }
        }
      }
    }
  }

  //To generate Sections and sublist of records for Scope Mapper
  generateScopeMapperSubList() {
    let scopeTableContentArray = [];
    var indexVal = 1;
    this.generateMapperSectionHeader(indexVal, 'Summary', 'Summary');
    this.generateScopeMapperSummary();
    for (var i = 0; i < this.Config.listOfAttributesUpdated.length; i++) {
      var attributeSymbol = this.Config.listOfAttributesUpdated[i].symbol;
      // var attributeSymbol = str[1].slice(0, 2);
      let sublistSubIndex = 0;
      let personafeatureArray = [];
      let personarequirementArray = [];
      let personaflowArray = [];
      let personaunspecArray = [];
      for (var j = 0; j < this.model.scopeMap.length; j++) {
        if (attributeSymbol == this.model.scopeMap[j].aType) {
          this.matchedEntity = this.model.listOfEUTs.find(
            (eut: any) => eut.eID == this.model.scopeMap[j].eID
          );
          if (this.matchedEntity) {
            if (this.selectedEntities.indexOf('TF') > -1) {
              if (this.matchedEntity.eType == 'TF') {
                personafeatureArray.push(this.matchedEntity);
              }
            }
            if (this.selectedEntities.indexOf('UR') > -1) {
              if (this.matchedEntity.eType == 'UR') {
                personarequirementArray.push(this.matchedEntity);
              }
            }
            if (this.selectedEntities.indexOf('BF') > -1) {
              if (this.matchedEntity.eType == 'BF') {
                personaflowArray.push(this.matchedEntity);
              }
            }
            if (this.selectedEntities.indexOf('XX') > -1) {
              if (this.matchedEntity.eType == 'XX') {
                personaunspecArray.push(this.matchedEntity);
              }
            }
          }
        }
      }
      if (
        personafeatureArray.length > 0 ||
        personarequirementArray.length > 0 ||
        personaflowArray.length > 0 ||
        personaunspecArray.length > 0
      ) {
        indexVal = indexVal + 1;
        this.generateMapperSectionHeader(
          indexVal,
          this.Config.listOfAttributesUpdated[i].name + ' (' + this.Config.listOfAttributesUpdated[i].symbol + ')',
          'Scope'
        );
        scopeTableContentArray.push(this.Config.listOfAttributesUpdated[i].name + ' (' + this.Config.listOfAttributesUpdated[i].symbol + ')');
      }
      if (personafeatureArray.length > 0) {
        sublistSubIndex++;
        this.generateMapperSectionSubheader(
          'Features',
          personafeatureArray,
          indexVal,
          sublistSubIndex,
          'Scope',
          'PP'
        );
        this.generateList(
          personafeatureArray,
          this.Config.listOfAttributesUpdated[i].symbol
        );
      }
      if (personarequirementArray.length > 0) {
        sublistSubIndex++;
        this.generateMapperSectionSubheader(
          'Requirements',
          personarequirementArray,
          indexVal,
          sublistSubIndex,
          'Scope',
          'PP'
        );
        this.generateList(
          personarequirementArray,
          this.Config.listOfAttributesUpdated[i].symbol
        );
      }
      if (personaflowArray.length > 0) {
        sublistSubIndex++;
        this.generateMapperSectionSubheader(
          'Flows',
          personaflowArray,
          indexVal,
          sublistSubIndex,
          'Scope',
          'PP'
        );
        this.generateList(
          personaflowArray,
          this.Config.listOfAttributesUpdated[i].symbol
        );
      }
      if (personaunspecArray.length > 0) {
        sublistSubIndex++;
        this.generateMapperSectionSubheader(
          'Unspecified',
          personaunspecArray,
          indexVal,
          sublistSubIndex,
          'Scope',
          'PP'
        );
        this.generateList(
          personaunspecArray,
          this.Config.listOfAttributesUpdated[i].symbol
        );
      }
    }
    if (scopeTableContentArray.length != 0) {
      // if(exportedData.length != 4){
      scopeTableContentArray.unshift('Summary');
      this.generateContentlist(scopeTableContentArray, 'Scope Mapper');
      // }
    } else {
      var html = '<div class="row strict">';
      html +=
        '<div class="alert alert-warning"><strong><div style="text-align: center;">There is no records to show. Go and check scope mapper.</div></strong></div>';
      html += '</div>';
      $('#exportSheet').append(html);
    }
  }

  //To generate Sections and sublist of records for Environment Mapper
  generateEnvironmentMapperSubList() {
    let envTableContentArray = [];
    var indexVal = 1;
    this.generateMapperSectionHeader(indexVal, 'Summary', 'Summary');
    this.generateEnvironmentSummary();
    for (var i = 0; i < this.model.envMap.length; i++) {
      indexVal = indexVal + 1;
      this.generateMapperSectionHeader(
        indexVal,
        this.model.envMap[i].envName,
        'Env'
      );
      // generateHeader(indexVal, model.envMap[i].envName);
      this.generateList(
        this.model.envMap[i].envList,
        'Environment'
      );
      envTableContentArray.push(this.model.envMap[i].envName);
    }
    if (envTableContentArray.length != 0) {
      // if(exportedData.length != 4){
      envTableContentArray.unshift('Summary');
      this.generateContentlist(envTableContentArray, 'Environment Mapper');
      // }
    } else {
      var html = '<div class="row strict">';
      html +=
        '<div class="alert alert-warning"><strong><div style="text-align: center;">There is no records to show. Go and check environment mapper.</div></strong></div>';
      html += '</div>';
      $('#exportSheet').append(html);
    }
  }
  //To generate Sections and sublist of records for Scenarios
  // function generateScenariosForEntitity() {
  //   for (var i = 0; i < model.listOfEUTs.length; i++) {
  //     indexVal = indexVal + 1;
  //     scenarioIndex = 0;
  //     let scenarioArray = [];
  //     for (var j = 0; j < model.scenarios.length; j++) {
  //       if (model.listOfEUTs[i].eID == model.scenarios[j].eID) {
  //         let personaMatchedArray = [];
  //         scenarioIndex = scenarioIndex + 1;
  //         model.scenarios[j]['index'] = scenarioIndex;
  //         this.matchedAttribute = appConst.listOfAttributes.find(att => att.symbol == model.scenarios[j].tID);
  //         if (this.matchedAttribute) {
  //           model.scenarios[j]['testType'] = this.matchedAttribute.name + ' (' + this.matchedAttribute.symbol + ')';
  //         }
  //         for (var k = 0; k < model.scenarios[j].persona.length; k++) {
  //           this.matchedPersona = model.persona.find(per => per.pType == model.scenarios[j].persona[k].trim());
  //           if (this.matchedPersona) {
  //             personaMatchedArray.push(this.matchedPersona.pName);
  //           }
  //           model.scenarios[j]['personas'] = personaMatchedArray;
  //         }
  //         scenarioArray.push(model.scenarios[j]);
  //       }
  //     }
  //     if (scenarioArray.length > 0) {
  //       generateHeader(indexVal, model.listOfEUTs[i].eName);
  //     }
  //     generateScenarioheader(indexVal, scenarioArray);
  //   }
  // }

  //To generate reports of records for deepdive
  generateReportsForEntities() {
    if (this.model.EUTdetails.length != 0) {
      // var selectedEUT: any;
      this.selectedEUT = JSON.parse(
        window.localStorage.getItem('deepdiveSelected') || '{}'
      );
      if (this.selectedEUT != null) {
        // this.matchedEntity = model.EUTdetails.find(eut => eut.eID == selectedEUT.eID);
        // if (this.matchedEntity) {
        //   console.log("AA",this.matchedEntity);
        this.generateDeepdivereport(1, this.selectedEUT);
        // }
        // } else {
        //   generateContentlist(model.listOfEUTs, "Deepdive");
        //   var count = 0;
        //   for (var i = 0; i < model.listOfEUTs.length; i++) {
        //     if (scenarioEntities.indexOf(model.listOfEUTs[i].eType) > -1) {
        //       count++;
        //       generateDeepdivereport(count, model.listOfEUTs[i]);
        //     }
        //   }
      }
    } else {
      var html = '<div class="row strict">';
      html +=
        '<div class="alert alert-warning"><strong><div style="text-align: center;">There is no records to show. Go and check Deepdive.</div></strong></div>';
      html += '</div>';
      $('#exportSheet').append(html);
    }
  }

  //To generate Sections and sublist of records for Scenarios
  generateScenariosForEntities() {
    var designerArray = [
      'Notes',
      'Behavioural conditions',
      'Acceptance criteria',
      'Inputs & Outcomes',
      'Potential issues',
      'Test scenarios',
    ];
    this.generateContentlist(designerArray, 'deepDive');
    this.matchedEUT = JSON.parse(
      window.localStorage.getItem('designerSelected') || '{}'
    );
    var html = '';
    var matchedEUT = this.model.listOfEUTs.find(
      (eut: any) => eut.eID == this.matchedEUT.eID
    );
    var EUTMatchedEType;
    var EUTMatchedtype;
    if (matchedEUT) {
      // console.log("this.matchedEUT", this.matchedEUT);
      EUTMatchedEType = matchedEUT.eType;
      if (matchedEUT.eType == 'TF') {
        EUTMatchedtype = 'Technical Feature';
      } else if (matchedEUT.eType == 'UR') {
        EUTMatchedtype = 'User Requirement';
      } else if (matchedEUT.eType == 'BF') {
        EUTMatchedtype = 'Business Flow';
      } else if (matchedEUT.eType == 'XX') {
        EUTMatchedtype = 'Unspecified';
      }
      html += '<div class="row strict">';
      html += '<h5>(' + EUTMatchedtype + ')</h5>';
      html += '<h5>' + this.getModuleName(this.matchedEUT) + ' | ' + matchedEUT.eName + '</h5>';
      html += '</div>';
    }
    $('#entityDetails').append(html);
    this.matchedSelectedEUT = this.model.EUTdetails.find(
      (eut: any) => eut.eID == matchedEUT.eID
    );
    var entityNotes = this.model.myNotes.find(
      (eut: any) => eut.eID == matchedEUT.eID
    );
    // console.log("this.matchedSelectedEUT", this.matchedSelectedEUT);
    if (this.matchedSelectedEUT) {
      var index = 0;
      for (var j = 0; j < designerArray.length; j++) {
        index++;
        if (designerArray[j] == 'Notes') {
          this.generateEntityNotes(
            index,
            designerArray[j],
            entityNotes
          );
        } else if (designerArray[j] == 'Behavioural conditions') {
          this.generateEntityBC(
            index,
            designerArray[j],
            this.matchedSelectedEUT
          );
        } else if (designerArray[j] == 'Acceptance criteria') {
          this.generateEntityAC(
            index,
            designerArray[j],
            this.matchedSelectedEUT
          );
        } else if (designerArray[j] == 'Inputs & Outcomes') {
          this.generateEntityOutcomes(
            index,
            designerArray[j],
            this.matchedSelectedEUT
          );
        } else if (designerArray[j] == 'Potential issues') {
          this.generateEntityPI(
            index,
            designerArray[j],
            this.matchedSelectedEUT
          );
        } else if (designerArray[j] == 'Test scenarios') {
          this.generateTestScenarios(
            index,
            designerArray[j],
            matchedEUT,
            'notitle'
          );
          // } else if (deepDiveArray[j] == 'Attributes to satisfy') {
          //   generateEntityAttributesToSatisfy(index, deepDiveArray[j], this.matchedSelectedEUT)
          //   }else if (deepDiveArray[j] == 'Interaction Details') {
          //     generateEntityInteracts(index, deepDiveArray[j], this.matchedSelectedEUT, EUTMatchedEType)
        }
      }
    }
    // let designerTableContentArray = [];
    // for (var i = 0; i < appConst.listOfAttributes.length; i++) {
    //   createHeader = 'False';
    //   let entityArray = [];
    //   scenarioindex = 0;
    //   for (var j = 0; j < model.listOfEUTs.length; j++) {
    //     let entityObj = {};
    //     let scenarioArray = [];
    //     entityObj.name = model.listOfEUTs[j].eName;
    //     for (var k = 0; k < model.scenarios.length; k++) {
    //       if (model.scenarios[k].tID == appConst.listOfAttributes[i].symbol && model.scenarios[k].eID == model.listOfEUTs[j].eID) {
    //         model.scenarios[k].entityName = model.listOfEUTs[j].eName;
    //         model.scenarios[k].eType = model.listOfEUTs[j].eType;
    //         scenarioindex = scenarioindex + 1;
    //         model.scenarios[k].index = scenarioindex;
    //         if (scenarioEntities.indexOf(model.scenarios[k].eType) > -1) {
    //           scenarioArray.push(model.scenarios[k]);
    //         }
    //       }
    //     }
    //     entityObj.scenarios = scenarioArray;
    //     entityArray.push(entityObj);
    //   }
    //   for (var l = 0; l < entityArray.length; l++) {
    //     if (entityArray[l].scenarios.length > 0) {
    //       createHeader = 'True';
    //     }
    //   }
    //   if (createHeader == 'True') {
    //     indexVal = indexVal + 1;
    //     generateHeader(indexVal, appConst.listOfAttributes[i].name);
    //     designerTableContentArray.push(appConst.listOfAttributes[i].name);
    //   }
    //   generateScenarioheader(indexVal, entityArray);
    // }
    // if (designerTableContentArray.length != 0) {
    //   generateContentlist(designerTableContentArray);
    //   generateSummary();
    // } else {
    //   html = '<div class="row strict">';
    //   html += '<div class="alert alert-warning"><strong><div style="text-align: center;">There is no records to show. Go and check test designer.</div></strong></div>';
    //   html += '</div>';
    //   $("#exportSheet").append(html);
    // }
  }

  generateExecutedScenariosForPlans() {
    let executorTableContentArray = [
      {
        title: 'Summary',
        sub: ['Execution summary', 'Outcome summary'],
      },
      {
        title: 'Execution details',
      },
    ];
    this.generateContentlist(executorTableContentArray, 'Executor');
    var html = '<hr class="mt-0 mb-0" style="border-top: 1px solid black;" >';
    $('#exportSheet').append(html);
    for (var i = 0; i < executorTableContentArray.length; i++) {
      this.generateExecutorPlannerReport(i + 1, executorTableContentArray[i]);
    }
    // for (var i = 0; i < model.tasks.length; i++) {
    //   if (plan == model.tasks[i].plan_name) {
    //     this.matchedAttribute = appConst.listOfAttributes.find(p => p.name == model.tasks[i].attribute);
    //     if (this.matchedAttribute) {
    //       html = '<table class="table table-hover table-bordered "><thead><tr><th class="w-80">Scenario</th><th>Executed</th></tr></thead><tbody>'

    //       for (var j = 0; j < model.scenarios.length; j++) {
    //         if (model.tasks[i].entity_Id == model.scenarios[j].eID &&
    //           this.matchedAttribute.symbol == model.scenarios[j].tID) {
    //           this.matchedRuninfo = model.runInfo.find(p => p.scenID == model.scenarios[j].scenID);
    //           if (this.matchedRuninfo) {
    //             generateExecutedScenariosTableDetails(model.scenarios[j].description, this.matchedRuninfo);
    //           }
    //         }
    //       }
    //     }
    //   }
    // }
    // html += '</tbody></table>';
    // $("#exportSheet").append(html);
  }
  generateExecutorPlannerReport(index: any, type: any) {
    if (type.title == 'Summary') {
      for (var m = 0; m < type.sub.length; m++) {
        if (type.sub[m] == 'Execution summary') {
          this.generateExecutionSummaryTableDetails(
            index,
            type,
            this.selectedPlanname
          );
        } else {
          this.generateOutcomeSummaryTableDetails(
            index,
            type,
            this.selectedPlanname
          );
        }
      }
    } else {
      // html += '<h5>Section   ' + index + '  : ' + type.title + '</h5>';
      this.generateExecutionDetailsTableDetails(
        index,
        type,
        this.selectedPlanname
      );
    }
    // $("#exportSheet").append(html);
    // if (type == 'Summary') {

    // }
  }
  generateExecutionSummaryTableDetails(
    index: any,
    type: any,
    selectedPlanname: any
  ) {
    selectedPlanname = window.localStorage.getItem('selectedPlanname');

    var tempPlanTasksList: any = [];
    for (var i = 0; i < this.model.tasks.length; i++) {
      if (this.model.tasks[i].plan_name == selectedPlanname) {
        if (this.model.tasks[i].toolType == 'ex') {
          tempPlanTasksList.push(this.model.tasks[i]);
        }
      }
    }
    var plannedEntities = [];
    var actualEntities = [];
    var totalEntities = [];
    var plannedEntitesTF = [];
    var actualEntitesTF = [];
    var plannedEntitesUR = [];
    var actualEntitesUR = [];
    var plannedEntitesBF = [];
    var actualEntitesBF = [];

    var plannedScenarios = [];
    var actualScenarios = [];
    for (var j = 0; j < tempPlanTasksList.length; j++) {
      // console.log("TEMp", tempPlanTasksList[j]);
      totalEntities.push(tempPlanTasksList[j].entity_Id);
      if (tempPlanTasksList[j].status == 3) {
        actualEntities.push(tempPlanTasksList[j].entity_Id);
      } else {
        plannedEntities.push(tempPlanTasksList[j].entity_Id);
      }
      if (tempPlanTasksList[j].entityType == 'TF') {
        plannedEntitesTF.push(tempPlanTasksList[j].entity_Id);
        if (tempPlanTasksList[j].status == 3) {
          actualEntitesTF.push(tempPlanTasksList[j].entity_Id);
        }
      } else if (tempPlanTasksList[j].entityType == 'UR') {
        plannedEntitesUR.push(tempPlanTasksList[j].entity_Id);
        if (tempPlanTasksList[j].status == 3) {
          actualEntitesUR.push(tempPlanTasksList[j].entity_Id);
        }
      } else if (tempPlanTasksList[j].entityType == 'BF') {
        plannedEntitesBF.push(tempPlanTasksList[j].entity_Id);
        if (tempPlanTasksList[j].status == 3) {
          actualEntitesBF.push(tempPlanTasksList[j].entity_Id);
        }
      }

      for (var k = 0; k < this.model.scenarios.length; k++) {
        var scenarioTotalExecuter = '';
        if (tempPlanTasksList[j].entity_Id == this.model.scenarios[k].eID) {
          var matchedAttr = this.clubbedAttributesArray.find(
            (attr: any) => attr.name == tempPlanTasksList[j].attribute
          );
          if (matchedAttr) {
            if (matchedAttr.symbol == this.model.scenarios[k].tID) {
              plannedScenarios.push(this.model.scenarios[k].scenID);
              scenarioTotalExecuter = this.getLatestExecutedScenario(
                this.model.scenarios[k].scenID
              );
              if (scenarioTotalExecuter) {
                actualScenarios.push(scenarioTotalExecuter);
              }
            }
          }
        }
      }
    }
    this.actualEntitiesArray = this.removeDuplicates(actualEntities);
    this.plannedEntitiesArray = this.removeDuplicates(plannedEntities);
    this.totalEntitiesArray = this.removeDuplicates(totalEntities);

    this.plannedEntitesTFArray = this.removeDuplicates(plannedEntitesTF);
    this.actualEntitesTFArray = this.removeDuplicates(actualEntitesTF);

    this.plannedEntitesURArray = this.removeDuplicates(plannedEntitesUR);
    this.actualEntitesURArray = this.removeDuplicates(actualEntitesUR);

    this.plannedEntitesBFArray = this.removeDuplicates(plannedEntitesBF);
    this.actualEntitesBFArray = this.removeDuplicates(actualEntitesBF);
    // console.log("actualEntitiesArray", actualEntitiesArray);
    // console.log("plannedEntitiesArray", plannedEntitiesArray);
    // console.log("totalEntitiesArray", totalEntitiesArray);
    var html1 = '<div class="row strict" id="' + type.title + '" >';
    html1 += '<h5>Section   ' + index + '  : ' + type.title + '</h5>';
    html1 +=
      '<h5 id="' +
      type.sub[0] +
      '" >' +
      index +
      '.1 : ' +
      type.sub[0] +
      '</h5>';
    html1 +=
      '<div class="row table-responsive-md"><table class="table table-bordered"><thead><tr><th class="w-40"></th><th Total>Planned tasks</th><th Total>Actual executed tasks</th></tr></thead><tbody class="textalignright" >';
    html1 +=
      '<tr><td  class="textalignleft">Total #tasks</td><td>' +
      tempPlanTasksList.length +
      '</td><td>' +
      actualEntities.length +
      '</td></tr>';
    html1 +=
      '<tr><td class="textalignleft">Entities to be validated</td><td>' +
      this.totalEntitiesArray.length +
      '</td><td>' +
      this.actualEntitiesArray.length +
      '</td></tr>';
    html1 +=
      '<tr><td>#Technical features</td><td>' +
      this.plannedEntitesTFArray.length +
      '</td><td>' +
      this.actualEntitesTFArray.length +
      '</td></tr>';
    html1 +=
      '<tr><td>#User requirements</td><td>' +
      this.plannedEntitesURArray.length +
      '</td><td>' +
      this.actualEntitesURArray.length +
      '</td></tr>';

    html1 +=
      '<tr><td>#Business flows</td><td>' +
      this.plannedEntitesBFArray.length +
      '</td><td>' +
      this.actualEntitesBFArray.length +
      '</td></tr>';
    html1 +=
      '<tr><td class="textalignleft">Scenarios to be validated</td><td>' +
      plannedScenarios.length +
      '</td><td>' +
      actualScenarios.length +
      '</td></tr>';

    for (var m = 0; m < this.clubbedAttributesArray.length; m++) {
      var attributePlannedScenarios = [];
      var attributeActualScenarios = [];
      for (var n = 0; n < tempPlanTasksList.length; n++) {
        if (this.clubbedAttributesArray[m].name == tempPlanTasksList[n].attribute) {
          for (var o = 0; o < this.model.scenarios.length; o++) {
            var scenarioExecuter = '';
            if (
              this.clubbedAttributesArray[m].symbol == this.model.scenarios[o].tID &&
              tempPlanTasksList[n].entity_Id == this.model.scenarios[o].eID
            ) {
              attributePlannedScenarios.push(this.model.scenarios[o].tID);
              scenarioExecuter = this.getLatestExecutedScenario(
                this.model.scenarios[o].scenID
              );
              if (scenarioExecuter) {
                attributeActualScenarios.push(scenarioExecuter);
              }
            }
          }
        }
      }
      if (attributePlannedScenarios.length > 0) {
        html1 +=
          '<tr><td>' +
          this.clubbedAttributesArray[m].name +
          '</td><td>' +
          attributePlannedScenarios.length +
          '</td><td>' +
          attributeActualScenarios.length +
          '</td></tr>';
      }
    }

    html1 += '</tbody></table></div>';

    $('#exportSheet').append(html1);
  }

  generateOutcomeSummaryTableDetails(
    index: any,
    type: any,
    selectedPlanname: any
  ) {
    var html3 =
      '<h5 id="' +
      type.sub[1] +
      '" >' +
      index +
      '.2 : ' +
      type.sub[1] +
      '</h5>';

    var tempPlanTasksList = [];
    var tempPlanTasksListAttributes = [];
    var taskPlannerEntities = [];
    var taskPlannerAttributes = [];
    var outcomeReportArray = [];
    for (var i = 0; i < this.model.tasks.length; i++) {
      if (this.model.tasks[i].plan_name == selectedPlanname) {
        if (this.model.tasks[i].toolType == 'ex') {
          this.matchedTaskAttribute = this.clubbedAttributesArray.find(
            (attr: any) => attr.name == this.model.tasks[i].attribute
          );
          if (this.matchedTaskAttribute) {
            if (outcomeReportArray.length != 0) {
              var matchedTask = outcomeReportArray.find(
                (task) =>
                  task.eID == this.model.tasks[i].entity_Id &&
                  task.symbol == this.matchedTaskAttribute.symbol
              );
              if (matchedTask) {
              } else {
                this.matchedTaskAttribute['entity_desc'] = this.model.tasks[
                  i
                ].entity_desc;
                this.matchedTaskAttribute['eID'] = this.model.tasks[
                  i
                ].entity_Id;
                outcomeReportArray.push(this.matchedTaskAttribute);
              }
            } else {
              this.matchedTaskAttribute['entity_desc'] = this.model.tasks[
                i
              ].entity_desc;
              this.matchedTaskAttribute['eID'] = this.model.tasks[i].entity_Id;
              this.matchedTaskAttribute['eType'] = this.model.tasks[i].entityType;
              outcomeReportArray.push(this.matchedTaskAttribute);
            }
          }
          // tempPlanTasksList.push(model.tasks[i].entity_Id);
          // tempPlanTasksListAttributes.push(model.tasks[i].attribute);
        }
      }
    }
    // console.log("outcomeReportArray", outcomeReportArray);
    // tempPlanTasksList = removeDuplicates(tempPlanTasksList);
    // tempPlanTasksListAttributes = removeDuplicates(tempPlanTasksListAttributes);
    // for (var l = 0; l < tempPlanTasksListAttributes.length; l++) {
    //   this.matchedTaskAttribute = listOfAttributes.find(attr => attr.name == tempPlanTasksListAttributes[l]);
    //   if (this.matchedTaskAttribute) {
    //     taskPlannerAttributes.push(this.matchedTaskAttribute)
    //   }
    // }
    // for (var j = 0; j < tempPlanTasksList.length; j++) {
    //   this.matchedTaskEntity = model.listOfEUTs.find(eut => eut.eID == tempPlanTasksList[j]);
    //   if (this.matchedTaskEntity) {
    //     taskPlannerEntities.push(this.matchedTaskEntity)
    //   }
    // }
    html3 +=
      '<div class="row table-responsive-md"><table class="table table-bordered"><thead><tr><th class="w-10">#</th><th Total >Entity</th><th Total >Test Type</th><th Total >Execution Status</th><th Total >#Issues</th></tr></thead><tbody>';
    var plannedOutcomeScenarios = [];
    // for (var k = 0; k < taskPlannerEntities.length; k++) {
    for (var m = 0; m < outcomeReportArray.length; m++) {
      var totalOutcomeScenarios = 0;
      var totalOutcomeExecutedScenarios = 0;
      var totalOutcomeExecutedScenariosFail = 0;
      for (var o = 0; o < this.model.scenarios.length; o++) {
        var scenarioExecuter = { outcome: '' };
        if (
          outcomeReportArray[m].symbol == this.model.scenarios[o].tID &&
          outcomeReportArray[m].eID == this.model.scenarios[o].eID
        ) {
          plannedOutcomeScenarios.push(this.model.scenarios[o].scenID);
          totalOutcomeScenarios++;
          scenarioExecuter = this.getLatestOutcomeExecutedScenario(
            this.model.scenarios[o].scenID
          );
          if (scenarioExecuter) {
            if (scenarioExecuter.outcome == 'F') {
              totalOutcomeExecutedScenariosFail++;
            }
            totalOutcomeExecutedScenarios++;
            // attributeActualScenarios.push(scenarioExecuter);
          }
        }
      }
      // console.log("totalOutcomeScenarios", totalOutcomeScenarios);
      // console.log("totalOutcomeExecutedScenarios", totalOutcomeExecutedScenarios);
      var outcomePercent = 0;
      if (totalOutcomeExecutedScenarios != 0) {
        outcomePercent = Math.round(
          (totalOutcomeExecutedScenarios / totalOutcomeScenarios) * 100
        );
      }
      html3 +=
        '<tr><td>' +
        (m + 1) +
        '</td><td>(' +
        outcomeReportArray[m].eType +
        ') ' +
        outcomeReportArray[m].entity_desc +
        '</td><td>' +
        outcomeReportArray[m].name +
        '</td><td class="textalignright pr-1" >' +
        outcomePercent +
        '%</td><td class="textalignright pr-1" >' +
        totalOutcomeExecutedScenariosFail +
        '</td></tr>';
    }
    // console.log("taskPlannerEntities",taskPlannerEntities[k]);
    // }
    html3 += '</tbody></table></div>';
    $('#exportSheet').append(html3);
  }

  getLatestExecutedScenario(scenID: any) {
    var matchedInfos = [];
    this.runInfo = false;
    for (var p = 0; p < this.model.runInfo.length; p++) {
      if (this.model.runInfo[p].scenID == scenID) {
        matchedInfos.push(this.model.runInfo[p]);
        this.runInfo = true;
      }
    }
    var latestDate = [];
    if (this.runInfo == true) {
      latestDate = matchedInfos.sort(this.getLatestDate('timeStamp', 'desc'));
    } else {
      latestDate = [{ status: 'N', outcome: 'F' }];
    }
    if (latestDate[0].status == 'Y') {
      return scenID;
    }
  }

  getLatestOutcomeExecutedScenario(scenID: any) {
    var matchedInfos = [];
    this.runInfo = false;
    for (var p = 0; p < this.model.runInfo.length; p++) {
      if (this.model.runInfo[p].scenID == scenID) {
        matchedInfos.push(this.model.runInfo[p]);
        this.runInfo = true;
      }
    }
    var latestDate = [];
    if (this.runInfo == true) {
      latestDate = matchedInfos.sort(this.getLatestDate('timeStamp', 'desc'));
    } else {
      latestDate = [{ status: 'N', outcome: 'F' }];
    }
    if (latestDate[0].status == 'Y') {
      return latestDate[0];
    }
  }

  generateExecutionDetailsTableDetails(
    index: any,
    type: any,
    selectedPlanname: any
  ) {
    var html = '<div class="row strict" id="' + type.title + '" >';
    html += '<hr class="mt-0 mb-0" style="border-top: 1px solid black;" >';
    html += '<h5>Section   ' + index + '  : ' + type.title + '</h5>';
    html += '</div>';
    $('#exportSheet').append(html);
    var entitiesArray: any = [];
    for (var i = 0; i < this.model.tasks.length; i++) {
      if (this.model.tasks[i].plan_name == selectedPlanname) {
        if (this.model.tasks[i].toolType == 'ex') {
          entitiesArray.push(this.model.tasks[i].entity_Id);
        }
      }
    }
    entitiesArray = this.removeDuplicates(entitiesArray);
    // console.log("entitiesArray", entitiesArray);
    var html2;
    for (var j = 0; j < entitiesArray.length; j++) {
      this.matchedEUT = this.model.listOfEUTs.find(
        (eut: any) => eut.eID == entitiesArray[j]
      );
      if (this.matchedEUT) {
        var entityIndex = 0;
        html2 =
          '<h5>' +
          index +
          '.' +
          (j + 1) +
          ' (' +
          this.matchedEUT.eType +
          ') ' +
          this.matchedEUT.eName +
          '</h5>';
        html2 +=
          '<div class="row table-responsive-md"><table class="table table-bordered "><thead><tr><th >#</th><th class="w-30  ">Scenario</th><th class="w-25  ">Test Type</th><th Total>Executed</th><th Total>Outcome</th></tr></thead><tbody>';
        for (var k = 0; k < this.model.scenarios.length; k++) {
          if (this.model.scenarios[k].eID == this.matchedEUT.eID) {
            this.matchedAttr = this.clubbedAttributesArray.find(
              (attr: any) => attr.symbol == this.model.scenarios[k].tID
            );
            if (this.matchedAttr) {
              entityIndex++;
              var matchedInfos = [];
              this.runInfo = false;
              for (var l = 0; l < this.model.runInfo.length; l++) {
                if (
                  this.model.runInfo[l].scenID == this.model.scenarios[k].scenID
                ) {
                  // console.log("runInfo",model.runInfo[k]);
                  matchedInfos.push(this.model.runInfo[l]);
                  this.runInfo = true;
                }
              }
              var latestDate = [];
              if (this.runInfo == true) {
                latestDate = matchedInfos.sort(
                  this.getLatestDate('timeStamp', 'desc')
                );
              } else {
                latestDate = [{ status: 'N', outcome: 'F' }];
              }
              // console.log("Scenario",model.scenarios[k]);
              // console.log("matchedInfos",matchedInfos);
              // console.log("latestDate",latestDate);
              var status = 'No';
              var outcome = 'Fail';
              if (latestDate[0].status == 'Y') {
                status = 'Yes';
                if (latestDate[0].outcome == 'P') {
                  outcome = 'Pass';
                }
              } else {
                status = 'No';
                outcome = 'Fail';
              }

              html2 +=
                '<tr><td>' +
                entityIndex +
                '</td><td>' +
                this.model.scenarios[k].description +
                '</td><td>' +
                this.matchedAttr.name +
                '</td><td>' +
                status +
                '</td><td>' +
                outcome +
                '</td></tr>';
            }
          }
        }
        html2 += '</tbody></table></div>';
      }
      $('#exportSheet').append(html2);
    }
  }

  getLatestDate(key: any, order = 'asc') {
    return function innerSort(a: any, b: any) {
      if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
        // property doesn't exist on either object
        return 0;
      }

      const varA = typeof a[key] === 'string' ? a[key].toUpperCase() : a[key];
      const varB = typeof b[key] === 'string' ? b[key].toUpperCase() : b[key];

      let comparison = 0;
      if (varA > varB) {
        comparison = 1;
      } else if (varA < varB) {
        comparison = -1;
      }
      return order === 'desc' ? comparison * -1 : comparison;
    };
  }

  generateChecklistReport() {
    var checklistData: any = window.localStorage.getItem('checklistDetails');
    this.selectedChecklist = JSON.parse(checklistData);
    this.checklistType = this.selectedChecklist.checkType;
    // this.ProjectServices.getChecklistData(
    //   window.localStorage.getItem('checklistDetails')
    // ).subscribe((response: any) => {
    // console.log("resss",response);
    // $("#exportSheet").append(response.record.content);
    // });
    // ProjectService.getChecklistData(this.selectedChecklist).then(function (params) {
    //   $("#exportSheet").append(params.record.content);
    // });
    var token = window.localStorage.getItem('publicToken');
    var jsonObjects = {
      projectID: this.projectId,
      checklistId: this.selectedChecklist.checklistId,
    };
    this.ProjectServices.getChecklistContent(jsonObjects, token).subscribe(
      (response: any) => {
        // console.log(response, 'res');
        if (response.statusCode == 200) {
          $('#exportSheet').append(response.record.content);
        } else {
        }
      }
    );
  }
  generateDeepdivereport(index: any, matchedEUT: any) {
    var deepDiveArray = [
      'Notes',
      'Behavioural conditions',
      'Acceptance criteria',
      'Inputs & Outcomes',
      'Potential issues',
      'Persona used by',
      'Attributes to satisfy',
      'Interaction Details',
    ];
    this.generateContentlist(deepDiveArray, 'deepDive');
    var html = '';
    this.matchedEUT = this.model.listOfEUTs.find(
      (eut: any) => eut.eID == matchedEUT.eID
    );
    if (this.matchedEUT) {
      // console.log("this.matchedEUT", this.matchedEUT);
      var EUTMatchedEType = this.matchedEUT.eType;
      var EUTMatchedtype;
      if (this.matchedEUT.eType == 'TF') {
        EUTMatchedtype = 'Technical Feature';
      } else if (this.matchedEUT.eType == 'UR') {
        EUTMatchedtype = 'User Requirement';
      } else if (this.matchedEUT.eType == 'BF') {
        EUTMatchedtype = 'Business Flow';
      } else if (this.matchedEUT.eType == 'XX') {
        EUTMatchedtype = 'Unspecified';
      }
      html += '<div class="row strict">';
      html += '<h5>(' + EUTMatchedtype + ')</h5>';
      html += '<h5>' + this.getModuleName(this.matchedEUT) + ' | ' + this.matchedEUT.eName + '</h5>';
      html += '</div>';
    }
    $('#entityDetails').append(html);
    this.matchedSelectedEUT = this.model.EUTdetails.find(
      (eut: any) => eut.eID == matchedEUT.eID
    );
    var entityNotes = this.model.myNotes.find(
      (eut: any) => eut.eID == matchedEUT.eID
    );
    // console.log("this.matchedSelectedEUT", this.matchedSelectedEUT);
    if (this.matchedSelectedEUT) {
      var index: any = 0;
      for (var j = 0; j < deepDiveArray.length; j++) {
        index++;
        if (deepDiveArray[j] == 'Notes') {
          this.generateEntityNotes(
            index,
            deepDiveArray[j],
            entityNotes
          );
        } else if (deepDiveArray[j] == 'Behavioural conditions') {
          this.generateEntityBC(
            index,
            deepDiveArray[j],
            this.matchedSelectedEUT
          );
        } else if (deepDiveArray[j] == 'Acceptance criteria') {
          this.generateEntityAC(
            index,
            deepDiveArray[j],
            this.matchedSelectedEUT
          );
        } else if (deepDiveArray[j] == 'Inputs & Outcomes') {
          this.generateEntityOutcomes(
            index,
            deepDiveArray[j],
            this.matchedSelectedEUT
          );
        } else if (deepDiveArray[j] == 'Potential issues') {
          this.generateEntityPI(
            index,
            deepDiveArray[j],
            this.matchedSelectedEUT
          );
        } else if (deepDiveArray[j] == 'Persona used by') {
          this.generateEntityPersonaUsedBy(
            index,
            deepDiveArray[j],
            this.matchedSelectedEUT
          );
        } else if (deepDiveArray[j] == 'Attributes to satisfy') {
          this.generateEntityAttributesToSatisfy(
            index,
            deepDiveArray[j],
            this.matchedSelectedEUT
          );
        } else if (deepDiveArray[j] == 'Interaction Details') {
          this.generateEntityInteracts(
            index,
            deepDiveArray[j],
            this.matchedSelectedEUT,
            EUTMatchedEType
          );
        }
      }
    }
    // html = '';
    // this.matchedSelectedEUT = model.EUTdetails.find(eut => eut.eID == matchedEUT.eID);
    // console.log("this.matchedSelectedEUT", this.matchedSelectedEUT);
    // if (this.matchedSelectedEUT) {
    //   html += '<div class="row strict" id="' + matchedSelectedEUT.eID + '" >';
    //   html += '<h5>Section ' + index + ' :  ' + matchedSelectedEUT.eName + ' </h5>';
    //   html += '</div>';
    // }
    // html += '<div class="row strict">';
    // html += '<h6><b>Notes</b> :  ' + this.matchedSelectedEUT.bDescription + ' </h6>';
    // html += '<h6><b>Behavioural conditions</b> :  ' + this.matchedSelectedEUT.bc + ' </h6>';
    // html += '<h6><b>Acceptance criteria</b> :  ' + this.matchedSelectedEUT.ac + ' </h6>';
    // html += '<h6><b>Outcomes</b> :  ' + this.matchedSelectedEUT.outcomes + ' </h6>';
    // html += '<h6><b>Potential issues</b> :  ' + this.matchedSelectedEUT.pIssues + ' </h6>';
    // var personaItems = '<b>The list of personas are : </b> ';
    // for (var i = 0; i < model.personaMap.length; i++) {
    //   if (this.matchedSelectedEUT.eID == model.personaMap[i].eID) {
    //     this.matchedPersona = model.persona.find(p => p.pType == model.personaMap[i].pType);
    //     if (this.matchedPersona) {
    //       personaItems += this.matchedPersona.pName + ","
    //     }
    //   }
    // }
    // html += '<h6>' + personaItems.slice(0, -1) + ' </h6>';
    // var attributeItems = '<b>To satisfy the list of attributes :</b> ';
    // for (var i = 0; i < model.scopeMap.length; i++) {
    //   if (this.matchedSelectedEUT.eID == model.scopeMap[i].eID) {
    //     this.matchedAttribute = appConst.listOfAttributes.find(p => p.symbol == model.scopeMap[i].aType);
    //     if (this.matchedAttribute) {
    //       attributeItems += this.matchedAttribute.name + ","
    //     }
    //   }
    // }
    // html += '<h6>' + attributeItems.slice(0, -1) + ' </h6>';
    // var usedItems = '<b>Used by :</b> ';
    // var interactsItems = '<b>Interacts with :</b> ';
    // for (var i = 0; i < model.interactionMap.length; i++) {
    //   if (this.matchedSelectedEUT.eID == model.interactionMap[i].eut1) {
    //     this.matchedEUT = model.listOfEUTs.find(p => p.eID == model.interactionMap[i].eut2);
    //     if (this.matchedEUT) {
    //       if (this.matchedEUT.eType == 'TF') {
    //         interactsItems += this.matchedEUT.eName + ","
    //       } else {
    //         usedItems += this.matchedEUT.eName + ","
    //       }
    //     }
    //   }
    // }
    // html += '<h6>' + interactsItems.slice(0, -1) + ' </h6>';
    // html += '<h6>' + usedItems.slice(0, -1); + ' </h6>';
    // html += '</div>';
    // $("#exportSheet").append(html);
  }
  //function to get modulename by moduleID
  getModuleName(eut: any) {
    var foundModule: any = this.model.modules.find(
      (mod: any) => mod.mID == eut.mID
    );
    return foundModule.mName;
  }
  getModuleNameByeID(eID: any) {
    var eut: any = this.model.listOfEUTs.find(
      (e: any) => e.eID == eID
    );
    var foundModule: any = this.model.modules.find(
      (mod: any) => mod.mID == eut.mID
    );
    return foundModule.mName;
  }
  //To generate notes of selected Entity
  generateEntityNotes(index: any, header: any, data: any) {
    var html = '<hr class="mt-0 mb-0" style="border-top: 1px solid black;" >';
    html += '<div class="row strict" id="' + header + '" >';
    html += '<h5>Section ' + index + ' : Entity ' + header + ' </h5>';
    html += '</div>';
    html += '<div class="row strict whiteSpace">';
    var desc = '';
    if (!data) {
      desc = 'NONE';
    } else {
      desc = data.notes;
    }
    html += '<pre>' + desc + ' </pre>';
    html += '</div>';
    html += '<hr class="mt-0 mb-0" style="border-top: 1px solid black;" >';
    $('#exportSheet').append(html);
  }
  //To generate behaviour conditions of selected Entity
  generateEntityBC(index: any, header: any, data: any) {
    var html = '<div class="row strict" id="' + header + '" >';
    html += '<h5>Section ' + index + ' :  ' + header + ' </h5>';
    html += '</div>';
    html += '<div class="row strict whiteSpace">';
    var desc = '';
    if (data.bc == '') {
      desc = 'NONE';
    } else {
      desc = data.bc;
    }
    html += '<pre>' + desc + ' </pre>';
    html += '</div>';
    html += '<hr class="mt-0 mb-0" style="border-top: 1px solid black;" >';
    $('#exportSheet').append(html);
  }
  //To generate acceptance citeria of selected Entity
  generateEntityAC(index: any, header: any, data: any) {
    var html = '<div class="row strict" id="' + header + '" >';
    html += '<h5>Section ' + index + ' :  ' + header + ' </h5>';
    html += '</div>';
    html += '<div class="row strict whiteSpace">';
    var desc = '';
    if (data.ac == '') {
      desc = 'NONE';
    } else {
      desc = data.ac;
    }
    html += '<pre>' + desc + ' </pre>';
    html += '</div>';
    html += '<hr class="mt-0 mb-0" style="border-top: 1px solid black;" >';
    $('#exportSheet').append(html);
  }
  //To generate outcomes of selected Entity
  generateEntityOutcomes(index: any, header: any, data: any) {
    var html = '<div class="row strict" id="' + header + '" >';
    html += '<h5>Section ' + index + ' :  ' + header + ' </h5>';
    html += '</div>';
    html += '<div class="row strict whiteSpace">';
    var desc = '';
    if (data.outcomes == '') {
      desc = 'NONE';
    } else {
      desc = data.outcomes;
    }
    html += '<pre>' + desc + ' </pre>';
    html += '</div>';
    html += '<hr class="mt-0 mb-0" style="border-top: 1px solid black;" >';
    $('#exportSheet').append(html);
  }
  //To generate potential issues of selected Entity
  generateEntityPI(index: any, header: any, data: any) {
    var html = '<div class="row strict" id="' + header + '" >';
    html += '<h5>Section ' + index + ' :  ' + header + ' </h5>';
    html += '</div>';
    html += '<div class="row strict whiteSpace">';
    var desc = '';
    if (data.pIssues == '') {
      desc = 'NONE';
    } else {
      desc = data.pIssues;
    }
    html += '<pre>' + desc + ' </pre>';
    html += '</div>';
    html += '<hr class="mt-0 mb-0" style="border-top: 1px solid black;" >';
    $('#exportSheet').append(html);
  }
  //To generate personas used by of selected Entity
  generateEntityPersonaUsedBy(index: any, header: any, data: any) {
    var html = '<div class="row strict" id="' + header + '" >';
    html += '<h5>Section ' + index + ' :  ' + header + ' </h5>';
    html += '</div>';
    html += '<div class="row strict">';
    var personaItems = '';
    for (var i = 0; i < this.model.personaMap.length; i++) {
      if (data.eID == this.model.personaMap[i].eID) {
        this.matchedPersona = this.model.persona.find(
          (p: any) => p.pType == this.model.personaMap[i].pType
        );
        if (this.matchedPersona) {
          personaItems += this.matchedPersona.pName + ',';
        }
      }
    }
    if (personaItems == '') {
      personaItems = 'NONE,';
    }
    html += '<h6>' + personaItems.slice(0, -1) + ' </h6>';
    html += '</div>';
    html += '<hr class="mt-0 mb-0" style="border-top: 1px solid black;" >';
    $('#exportSheet').append(html);
  }
  //To generate Attributes to satisfy of selected Entity
  generateEntityAttributesToSatisfy(index: any, header: any, data: any) {
    var html = '<div class="row strict" id="' + header + '" >';
    html += '<h5>Section ' + index + ' :  ' + header + ' </h5>';
    html += '</div>';
    html += '<div class="row strict">';
    var attributeItems = '';
    for (var i = 0; i < this.model.scopeMap.length; i++) {
      if (data.eID == this.model.scopeMap[i].eID) {
        this.matchedAttribute = this.Config.listOfAttributesUpdated.find(
          (p: any) => p.symbol == this.model.scopeMap[i].aType
        );
        if (this.matchedAttribute) {
          attributeItems += this.matchedAttribute.name + ',';
        }
      }
    }
    if (attributeItems == '') {
      attributeItems = 'NONE,';
    }
    html += '<h6>' + attributeItems.slice(0, -1) + ' </h6>';
    html += '</div>';
    html += '<hr class="mt-0 mb-0" style="border-top: 1px solid black;" >';
    $('#exportSheet').append(html);
  }

  //To generate interacts or used by of selected Entity
  generateEntityInteracts(index: any, header: any, data: any, type: any) {
    var html = '<div class="row strict" id="' + header + '" >';
    html += '<h5>Section ' + index + ' :  ' + header + ' </h5>';
    html += '</div>';
    $('#exportSheet').append(html);
    // html = '<div class="row strict">';
    var itemsTF = '';
    var itemsUR = '';
    var itemsBF = '';
    var itemsXX = '';
    for (var i = 0; i < this.model.interactionMap.length; i++) {
      if (data.eID == this.model.interactionMap[i].eut1) {
        this.matchedEUT = this.model.listOfEUTs.find(
          (p: any) => p.eID == this.model.interactionMap[i].eut2
        );
        if (this.matchedEUT) {
          if (this.matchedEUT.eType == 'TF') {
            itemsTF += this.getModuleName(this.matchedEUT) + ' | ' + this.matchedEUT.eName + ', ';
          } else if (this.matchedEUT.eType == 'UR') {
            itemsUR += this.getModuleName(this.matchedEUT) + ' | ' + this.matchedEUT.eName + ', ';
          } else if (this.matchedEUT.eType == 'BF') {
            itemsBF += this.getModuleName(this.matchedEUT) + ' | ' + this.matchedEUT.eName + ', ';
          } else if (this.matchedEUT.eType == 'XX') {
            itemsXX += this.getModuleName(this.matchedEUT) + ' | ' + this.matchedEUT.eName + ', ';
          }
        }
      }
    }
    var header1 = 'Interacts with';
    var header2 = 'Interacts with';
    var header3 = 'Interacts with';
    var header4 = 'Interacts with';
    if (type == 'TF') {
      header2 = 'Used by';
      header3 = 'Used by';
    } else if (type == 'UR') {
      header3 = 'Used by';
    }
    if (itemsTF == '') {
      itemsTF = 'NONE,';
    }
    if (itemsUR == '') {
      itemsUR = 'NONE,';
    }
    if (itemsBF == '') {
      itemsBF = 'NONE,';
    }
    if (itemsXX == '') {
      itemsXX = 'NONE,';
    }
    html = '<div class="row strict">';
    html += '<h5>' + index + '.1 :  ' + header1 + ' Technical Feature(s)</h5>';
    html += '</div>';
    html += '<h6>' + itemsTF.slice(0, -1) + ' </h6>';
    html += '<div class="row strict">';
    html += '<h5>' + index + '.2 :  ' + header2 + ' User Requirement(s)</h5>';
    html += '</div>';
    html += '<h6>' + itemsUR.slice(0, -1) + ' </h6>';
    html += '<div class="row strict">';
    html += '<h5>' + index + '.3 :  ' + header3 + ' Business Flow(s)</h5>';
    html += '</div>';
    html += '<h6>' + itemsBF.slice(0, -1) + ' </h6>';
    html += '<h5>' + index + '.4 :  ' + header4 + ' Unspecified(s)</h5>';
    html += '</div>';
    html += '<h6>' + itemsXX.slice(0, -1) + ' </h6>';
    // html += '<hr class="mt-0 mb-0" style="border-top: 1px solid black;" >';
    $('#exportSheet').append(html);
  }

  generateTestScenarios(index: any, header: any, matchedEUT: any, type: any) {
    if (type == 'title') {
      var html = '<hr class="mt-0 mb-0" style="border-top: 1px solid black;" >';
      html += '<div class="row strict" id="' + header + '" >';
    } else {
      html = '<div class="row strict" id="' + header + '" >';
    }
    if (type == 'title') {
      html +=
        '<h5>Section ' +
        index +
        ' : (' +
        matchedEUT.eType +
        ') ' +
        header +
        ' </h5>';
    } else {
      html += '<h5>Section ' + index + ' :  ' + header + ' </h5>';
    }
    html += '</div>';
    // console.log("matchedEUT", matchedEUT);
    var attributesInvolved = [];
    for (var i = 0; i < this.model.scenarios.length; i++) {
      if (this.model.scenarios[i].eID == matchedEUT.eID) {
        attributesInvolved.push(this.model.scenarios[i].tID);
      }
    }
    this.attributesDesigner = this.removeDuplicates(attributesInvolved);
    this.attributesDesigner.unshift('Summary');
    // console.log(" attributesDesigner", attributesDesigner);
    var subIndex = 0;
    for (var j = 0; j < this.attributesDesigner.length; j++) {
      subIndex++;
      this.generateDesignerSummary(
        index,
        subIndex,
        this.attributesDesigner[j],
        matchedEUT,
        html
      );
    }
  }

  generateDesignerSummary(
    index: any,
    subIndex: any,
    type: any,
    matchedEUT: any,
    html: any
  ) {
    // console.log("index", index);
    // console.log("subIndex", subIndex);
    // console.log("type", type);
    if (type == 'Summary') {
      var html1 = '<h6>' + index + '.' + subIndex + ' ' + type + '</h6>';
      html1 +=
        '<div class="row table-responsive-md pt-0 pb-0"><table class="table table-bordered"><thead><tr><th class="w-40">Applicable tests</th><th Total>Total scenarios</th><th Total>Positive</th><th Total>Negative</th></tr></thead><tbody>';
      for (var j = 0; j < this.attributesDesigner.length; j++) {
        var totalScenario = 0;
        var totalScenarioPositive = 0;
        var totalScenarioNegative = 0;
        for (var k = 0; k < this.model.scenarios.length; k++) {
          // if (attributesDesigner[j] != 'Summary') {
          if (
            this.model.scenarios[k].tID == this.attributesDesigner[j] &&
            this.model.scenarios[k].eID == matchedEUT.eID
          ) {
            totalScenario++;
            if (this.model.scenarios[k].cr == '+') {
              totalScenarioPositive++;
            } else {
              totalScenarioNegative++;
            }
          }
          // }
        }
        this.matchedAttr = this.clubbedAttributesArray.find(
          (attr: any) => attr.symbol == this.attributesDesigner[j]
        );
        if (this.matchedAttr) {
          html1 +=
            '<tr><td>' +
            this.matchedAttr.name +
            ' test</td>' +
            '<td class="textalignright pr-1">' +
            totalScenario +
            '</td>' +
            '<td class="textalignright pr-1">' +
            totalScenarioPositive +
            '</td>' +
            '<td class="textalignright pr-1">' +
            totalScenarioNegative +
            '</td></tr>';
        }
        // console.log("totalScenario", totalScenario);
        // console.log("totalScenarioPositive", totalScenarioPositive);
        // console.log("totalScenarioNegative", totalScenarioNegative);
      }

      html1 += '</tbody></table></div>';
      if (this.attributesDesigner.length == 1) {
        html1 = '<p>NONE</p>';
      }
      if (this.attributesDesigner.length > 1) {
        $('#exportSheet').append(html);
        $('#exportSheet').append(html1);
      }
      //  else {
      //   entitiesWithNoScenarios.push(matchedEUT);
      //   console.log("entitiesWithNoScenarios", entitiesWithNoScenarios);
      // }
    } else {
      this.matchedAttr = this.clubbedAttributesArray.find(
        (attr: any) => attr.symbol == type
      );
      if (this.matchedAttr) {
        var totoalScenarios = 0;
        for (var m = 0; m < this.model.scenarios.length; m++) {
          if (
            this.model.scenarios[m].eID == matchedEUT.eID &&
            this.model.scenarios[m].tID == type
          ) {
            totoalScenarios++;
          }
        }
        html =
          '<h6>' +
          index +
          '.' +
          subIndex +
          ' ' +
          this.matchedAttr.name +
          ' (' +
          totoalScenarios +
          ')</h6>';
        $('#exportSheet').append(html);
        var superIndex = 0;
        for (var l = 0; l < this.model.scenarios.length; l++) {
          if (
            this.model.scenarios[l].eID == matchedEUT.eID &&
            this.model.scenarios[l].tID == type
          ) {
            superIndex++;
            var priority = '';
            if (this.model.scenarios[l].priority == '1') {
              priority = 'P1';
            } else if (this.model.scenarios[l].priority == '2') {
              priority = 'P2';
            } else if (this.model.scenarios[l].priority == '3') {
              priority = 'P3';
            }
            html =
              '<p>' +
              superIndex +
              '. (' +
              this.model.scenarios[l].cr +
              // ',' +
              // this.model.scenarios[l].persona.length +
              ') ' +
              this.model.scenarios[l].description +
              '</p>';
            $('#exportSheet').append(html);
          }
        }
        // $("#exportSheet").append(html);
      }
    }
  }

  generateScenariosForEUTTypes() {
    this.scenarioEntities = window.localStorage.getItem('scenarioEntity');
    if (
      this.scenarioEntities.indexOf('TF') > -1 &&
      this.scenarioEntities.indexOf('UR') > -1 &&
      this.scenarioEntities.indexOf('BF') > -1
    ) {
      this.toolReportName =
        'Scenarios report for Features, Requirements & Flows';
    } else if (
      this.scenarioEntities.indexOf('TF') > -1 &&
      this.scenarioEntities.indexOf('UR') > -1
    ) {
      this.toolReportName = 'Scenarios report for Features & Requirements';
    } else if (
      this.scenarioEntities.indexOf('BF') > -1 &&
      this.scenarioEntities.indexOf('UR') > -1
    ) {
      this.toolReportName = 'Scenarios report for Requirements & Flows';
    } else if (
      this.scenarioEntities.indexOf('TF') > -1 &&
      this.scenarioEntities.indexOf('BF') > -1
    ) {
      this.toolReportName = 'Scenarios report for Features & Flows';
    } else if (this.scenarioEntities.indexOf('TF') > -1) {
      this.toolReportName = 'Scenarios report for Features';
    } else if (this.scenarioEntities.indexOf('UR') > -1) {
      this.toolReportName = 'Scenarios report for Requirements';
    } else if (this.scenarioEntities.indexOf('BF') > -1) {
      this.toolReportName = 'Scenarios report for Flows';
    }
    // toolReportName = this.exportedData[i];
    var html = '<h5><b>Table of contents</b></h5>';
    var listOfEntities = this.model.listOfEUTs;
    listOfEntities.unshift({ eID: 'Summary' });
    var count = 0;
    for (var i = 0; i < listOfEntities.length; i++) {
      if (listOfEntities[i].eID == 'Summary') {
        count++;
        // href="/#!/export#' + listOfEntities[i].eID + '"
        html +=
          '<b><a  class="list-group-item">' +
          count +
          '. ' +
          listOfEntities[i].eID +
          '</a></b>';
      } else {
        var ScenariosExists = this.model.scenarios.find(
          (scen: any) => scen.eID == listOfEntities[i].eID
        );
        if (ScenariosExists) {
          if (this.scenarioEntities.indexOf(listOfEntities[i].eType) > -1) {
            count++;
            // href="/#!/export#' + listOfEntities[i].eName + '"
            html +=
              '<b><a  class="list-group-item">' +
              count +
              '. (' +
              listOfEntities[i].eType +
              ') ' +
              listOfEntities[i].eName +
              '</a></b>';
          }
        }
      }
    }
    // href="' + appConst.redirectHostAddress + 'export#noScenarios"
    html +=
      '<b><a  class="list-group-item">' +
      (count + 1) +
      '. Entities that have no scenarios</a></b>';

    // html += '<hr class="mt-0 mb-0" style="border-top: 1px solid black;" >';
    $('#contentlist').append(html);
    this.generateScenariosSummary('1', 'Summary');
    var EntityCount = 1;
    for (var k = 0; k < listOfEntities.length; k++) {
      var ScenariosEntityExists = this.model.scenarios.find(
        (scen: any) => scen.eID == listOfEntities[k].eID
      );
      if (ScenariosEntityExists) {
        if (this.scenarioEntities.indexOf(listOfEntities[k].eType) > -1) {
          EntityCount++;
          this.generateTestScenarios(
            EntityCount,
            listOfEntities[k].eName,
            listOfEntities[k],
            'title'
          );
        }
      } else {
        if (listOfEntities[k].eID != 'Summary') {
          if (this.scenarioEntities.indexOf(listOfEntities[k].eType) > -1) {
            this.entitiesWithNoScenarios.push(listOfEntities[k]);
          }
        }
      }
    }
    // if (entitiesWithNoScenarios.length > 1) {
    html = '<hr class="mt-0 mb-0" style="border-top: 1px solid black;" >';
    html += '<div class="row strict" id="noScenarios" >';
    html +=
      '<h5>Section ' +
      (EntityCount + 1) +
      ' : Entities that have no scenarios</h5>';
    html += '</div>';
    for (var n = 0; n < this.entitiesWithNoScenarios.length; n++) {
      html +=
        '<p>' +
        (EntityCount + 1) +
        '.' +
        (n + 1) +
        ' (' +
        this.entitiesWithNoScenarios[n].eType +
        ') ' +
        this.entitiesWithNoScenarios[n].eName +
        '</p>';
    }
    if (this.entitiesWithNoScenarios.length == 0) {
      html += 'There are no entities to display.';
    }
    $('#exportSheet').append(html);
    // }
  }

  generateScenariosSummary(index: any, header: any) {
    var colSpanCount = 0;
    if (this.scenarioEntities.indexOf('TF') > -1) {
      colSpanCount++;
    }
    if (this.scenarioEntities.indexOf('UR') > -1) {
      colSpanCount++;
    }
    if (this.scenarioEntities.indexOf('BF') > -1) {
      colSpanCount++;
    }

    var html = '<hr class="mt-0 mb-0" style="border-top: 1px solid black;" >';
    html += '<div class="row strict" id="' + header + '" >';
    html += '<h5>Section ' + index + ' : ' + header + ' </h5>';
    html += '</div>';
    html +=
      '<div class="row table-responsive-md"><table class="table table-bordered" >';
    html += '<tbody>';
    html +=
      '<tr><td></td><td Total colspan="' +
      colSpanCount +
      '">#scenarios</td></tr>';
    html += '<tr><td class="w-40  ">Test types</td>';
    if (this.scenarioEntities.indexOf('TF') > -1) {
      html += '<td Total>Technical features</td>';
    }
    if (this.scenarioEntities.indexOf('UR') > -1) {
      html += '<td Total>User requirements</td>';
    }
    if (this.scenarioEntities.indexOf('BF') > -1) {
      html += '<td Total>Business flows</td>';
    }
    html += '</tr>';
    for (var i = 0; i < this.clubbedAttributesArray.length; i++) {
      var scenarioTFCount = 0;
      var scenarioURCount = 0;
      var scenarioBFCount = 0;
      for (var j = 0; j < this.model.scenarios.length; j++) {
        if (this.clubbedAttributesArray[i].symbol == this.model.scenarios[j].tID) {
          // console.log("eID",this.model.scenarios[j]);
          // console.log("eID",this.model.scenarios[j].eID);
          if (this.model.scenarios[j].eType == 'TF') {
            scenarioTFCount++;
          } else if (this.model.scenarios[j].eType == 'UR') {
            scenarioURCount++;
          } else if (this.model.scenarios[j].eType == 'BF') {
            scenarioBFCount++;
          }
        }
      }
      // if (scenarioCount != 0) {
      html += '<tr><td>' + this.clubbedAttributesArray[i].name + ' test</td>';
      if (this.scenarioEntities.indexOf('TF') > -1) {
        html += '<td class="textalignright pr-1">' + scenarioTFCount + '</td>';
      }
      if (this.scenarioEntities.indexOf('UR') > -1) {
        html += '<td class="textalignright pr-1">' + scenarioURCount + '</td>';
      }
      if (this.scenarioEntities.indexOf('BF') > -1) {
        html += '<td class="textalignright pr-1">' + scenarioBFCount + '</td>';
      }
      html += '</tr>';
      // }
    }
    // html += '<tr><td>#Features</td><td>' + featureArray.length + '</td></tr>';
    html += '</tbody></table></div>';
    $('#exportSheet').append(html);
  }
  //removes duplicate from an array
  removeDuplicates(array: any) {
    return array.filter((a: any, b: any) => array.indexOf(a) === b);
  }
  //To generate summary of all scenarios
  generateSummary() {
    let summaryArray = [];
    for (var i = 0; i < this.clubbedAttributesArray.length; i++) {
      var featureObj = {
        symbol: '',
        name: '',
        scenarioCount: 0,
        eType: '',
        eutCount: 0,
        positiveCount: 0,
        negativeCount: 0,
      };
      var requirementObj = {
        symbol: '',
        name: '',
        scenarioCount: 0,
        eType: '',
        eutCount: 0,
        positiveCount: 0,
        negativeCount: 0,
      };
      var flowObj = {
        symbol: '',
        name: '',
        scenarioCount: 0,
        eType: '',
        eutCount: 0,
        positiveCount: 0,
        negativeCount: 0,
      };
      let featureArr = [];
      let requirementArr = [];
      let flowArr = [];
      let featureCount = 1;
      let requirementCount = 1;
      let flowCount = 1;
      let featureScenarioCount = 1;
      let requirementScenarioCount = 1;
      let flowScenarioCount = 1;
      let featurePositiveCount = 1;
      let featureNegativeCount = 1;
      let requirementPositiveCount = 1;
      let requirementNegativeCount = 1;
      let flowPositiveCount = 1;
      let flowNegativeCount = 1;
      for (var k = 0; k < this.model.scenarios.length; k++) {
        if (this.model.scenarios[k].tID == this.clubbedAttributesArray[i].symbol) {
          if (this.scenarioEntities.indexOf('TF') > -1) {
            if (this.model.scenarios[k].eType == 'TF') {
              featureObj.symbol = this.clubbedAttributesArray[i].symbol;
              featureObj.name = this.clubbedAttributesArray[i].name;
              featureObj.scenarioCount = featureScenarioCount++;
              featureObj.eType = this.model.scenarios[k].eType;
              var featureEntity = featureArr.find(
                (eut) => eut == this.model.scenarios[k].eID
              );
              if (!featureEntity) {
                featureArr.push(this.model.scenarios[k].eID);
                featureObj.eutCount = featureCount++;
              }
              if (this.model.scenarios[k].cr == '+') {
                featureObj.positiveCount = featurePositiveCount++;
              } else {
                featureObj.negativeCount = featureNegativeCount++;
              }
            }
          }
          if (this.scenarioEntities.indexOf('UR') > -1) {
            if (this.model.scenarios[k].eType == 'UR') {
              requirementObj.symbol = this.clubbedAttributesArray[i].symbol;
              requirementObj.name = this.clubbedAttributesArray[i].name;
              requirementObj.scenarioCount = requirementScenarioCount++;
              requirementObj.eType = this.model.scenarios[k].eType;
              var requirementeEntity = requirementArr.find(
                (eut) => eut == this.model.scenarios[k].eID
              );
              if (!requirementeEntity) {
                requirementArr.push(this.model.scenarios[k].eID);
                requirementObj.eutCount = requirementCount++;
              }
              if (this.model.scenarios[k].cr == '+') {
                requirementObj.positiveCount = requirementPositiveCount++;
              } else {
                requirementObj.negativeCount = requirementNegativeCount++;
              }
            }
          }
          if (this.scenarioEntities.indexOf('BF') > -1) {
            if (this.model.scenarios[k].eType == 'BF') {
              flowObj.symbol = this.clubbedAttributesArray[i].symbol;
              flowObj.name = this.clubbedAttributesArray[i].name;
              flowObj.scenarioCount = flowScenarioCount++;
              flowObj.eType = this.model.scenarios[k].eType;
              var flowEntity = flowArr.find(
                (eut: any) => eut == this.model.scenarios[k].eID
              );
              if (!flowEntity) {
                flowArr.push(this.model.scenarios[k].eID);
                flowObj.eutCount = flowCount++;
              }
              if (this.model.scenarios[k].cr == '+') {
                flowObj.positiveCount = flowPositiveCount++;
              } else {
                flowObj.negativeCount = flowNegativeCount++;
              }
            }
          }
        }
      }
      if (Object.keys(featureObj).length > 0) {
        summaryArray.push(featureObj);
      }
      if (Object.keys(requirementObj).length > 0) {
        summaryArray.push(requirementObj);
      }
      if (Object.keys(flowObj).length > 0) {
        summaryArray.push(flowObj);
      }
    }
    this.indexVal = this.indexVal + 1;
    this.generateHeader(this.indexVal, 'Summary');
    this.generateSummaryTable(summaryArray);
  }

  //To generate suites of all scenarios
  generateScenariosForSuites() {
    var selectedSuite = window.localStorage.getItem('selectedSuite');
    var eutTypes = ['TF', 'UR', 'BF'];
    if (selectedSuite != null) {
      var suites = [{ suiteName: selectedSuite }];
      this.generateContentlist(suites, 'suites');
      for (var i = 0; i < this.model.suites.length; i++) {
        if (this.model.suites[i].suiteName == selectedSuite) {
          this.indexVal = this.indexVal + 1;
          var secIndex = 0;
          this.generateHeader(this.indexVal, this.model.suites[i].suiteName);
          var subindex = 0;
          for (var k = 0; k < this.model.listOfEUTs.length; k++) {
            for (var l = 0; l < eutTypes.length; l++) {
              if (eutTypes[l] == this.model.listOfEUTs[k].eType) {
                var matchedEntityScenario = this.model.scenarios.find(
                  (sec: any) => sec.eID == this.model.listOfEUTs[k].eID
                );
                if (matchedEntityScenario) {
                  // console.log("1",this.matchedEntityScenario.scenID);
                  // console.log("2",model.suites[i]);
                  if (
                    this.model.suites[i].scenarios.indexOf(
                      matchedEntityScenario.scenID
                    ) > -1
                  ) {
                    subindex++;
                    secIndex = 0;
                    this.generateSuiteEntityHeader(
                      subindex,
                      this.model.listOfEUTs[k]
                    );
                    for (
                      var j = 0;
                      j < this.model.suites[i].scenarios.length;
                      j++
                    ) {
                      var matchedScenario = this.model.scenarios.find(
                        (sec: any) =>
                          sec.scenID ==
                          this.model.suites[i].scenarios[j].trim() &&
                          sec.eID == this.model.listOfEUTs[k].eID
                      );
                      if (matchedScenario) {
                        secIndex = secIndex + 1;
                        this.generateScenarioList(
                          this.indexVal,
                          secIndex,
                          matchedScenario.description,
                          matchedScenario.cr,
                          matchedScenario.eID,
                          matchedScenario.priority
                        );
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      this.generateContentlist(this.model.suites, 'suites');
      for (var i = 0; i < this.model.suites.length; i++) {
        this.indexVal = this.indexVal + 1;
        secIndex = 0;
        this.generateHeader(this.indexVal, this.model.suites[i].suiteName);
        for (var j = 0; j < this.model.suites[i].scenarios.length; j++) {
          var matchedScenario = this.model.scenarios.find(
            (sec: any) => sec.scenID == this.model.suites[i].scenarios[j].trim()
          );
          if (matchedScenario) {
            secIndex = secIndex + 1;
            this.generateScenarioList(
              this.indexVal,
              secIndex,
              matchedScenario.description,
              matchedScenario.cr,
              matchedScenario.eID,
              matchedScenario.priority
            );
          }
        }
      }
    }
  }

  // To generate Table of content for Prject Summary
  generateProjectSummaryContentlist() {
    let k = 0;
    var html = '<h5>Table of contents</h5>';
    html +=
      '<a href="/exportReport#' + 'projectSummary' + '" class="list-group-item">' + (k + 1) + '. ' + 'Project Summary' + '</a>';
    $('#contentlist').append(html);
  }

  // To generate Table of content for Prject Summary
  generateDesignSummaryContentlist() {
    let k = 0;
    var html = '<h5>Table of contents</h5>';
    html +=
      '<a href="/exportReport#' + 'designSummary' + '" class="list-group-item">' + (k + 1) + '. ' + 'Design Summary' + '</a>';
    // $('#contentlist').append(html);
  }
  // To generate Table of content for Design summary
  generateDesignSumContentlist(
    Module: any,
    Test: any,
    Levels: any,
    TestType: any,
    Level: any
  ) {
    let k = 0;
    // html = '';
    var html = '<h5>Table of contents</h5>';
    html +=
      '<a href="/exportReport#' + 'projectSummary' + '" class="list-group-item">' + (k + 1) + '. ' + 'Project Summary' + '</a>';
    k++;
    // if (Test.length > 0) {
    html +=
      '<a href="/exportReport#' + 'Scenario distribution' + '" class="list-group-item">' + (k + 1) + '. ' + 'Scenario distribution by Level, Module & Type' + '</a>';
    k++;
    // }
    // if (Module.length > 0) {
    html +=
      '<a href="/exportReport#' + 'Scenario distribution by module' + '" class="list-group-item">' +
      (k + 1) +
      '. ' +
      'Module wise scenarios by Type & Level' +
      '</a>';
    k++;

    //   html +=
    //   '<a href="/exportReport#' + 'Abbreviations' + '" class="list-group-item">' +
    //   (k + 1) +
    //   '. ' +
    //   'Abbreviations' +
    //   '</a>';
    // k++;
    // }
    // if (Levels.length > 0) {
    //   html +=
    //     '<a href="/exportReport#' + 'Level-wise' + '" class="list-group-item">' + (k + 1) + '. ' + 'Level-wise' + '</a>';
    //   k++;
    // }
    // if (TestType.length > 0) {
    //   html +=
    //     '<a href="/exportReport#' + 'Test-type' + '" class="list-group-item">' + (k + 1) + '. ' + 'Test Type' + '</a>';
    //   k++;
    // }
    // if (Level.length > 0) {
    //   html +=
    //     '<a href="/exportReport#' + 'Level' + '" class="list-group-item">' + (k + 1) + '. ' + 'Level' + '</a>';
    //   k++;
    // }
    $('#contentlist').append(html);
  }
  // To generate Table of content for TestManager
  generateTMContentlist(
    EUT: any,
    Test: any,
    Suites: any,
    Module: any,
    Levels: any
  ) {
    let k = 0;
    // html = '';
    var html = '<h5>Table of contents</h5>';
    if (EUT.length > 0) {
      html +=
        '<a href="/exportReport#' + 'EUT-wise' + '" class="list-group-item">' + (k + 1) + '. ' + 'EUT-wise' + '</a>';
      k++;
    }
    if (Test.length > 0) {
      html +=
        '<a href="/exportReport#' + 'Test-wise' + '" class="list-group-item">' + (k + 1) + '. ' + 'Test-wise' + '</a>';
      k++;
    }
    if (Module.length > 0) {
      html +=
        '<a href="/exportReport#' + 'Module-wise' + '" class="list-group-item">' +
        (k + 1) +
        '. ' +
        'Module-wise' +
        '</a>';
      k++;
    }
    if (Levels.length > 0) {
      html +=
        '<a href="/exportReport#' + 'Level-wise' + '" class="list-group-item">' + (k + 1) + '. ' + 'Level-wise' + '</a>';
      k++;
    }
    if (Suites.length > 0) {
      html +=
        '<a href="/exportReport#' + 'Suite-wise' + '" class="list-group-item">' + (k + 1) + '. ' + 'Suite-wise' + '</a>';
      k++;
    }
    $('#contentlist').append(html);
  }
  //To generate Header for the records
  generateDesignSummarySectionHeader(index: any, header: any, array: any, tableHead: any) {
    var html = '<hr class="mt-0 mb-0" style="border-top: 1px solid black;" >';
    html += '<div class="row strict" id="' + header + '" >';
    html += '<h5>Section ' + index + ' : Design summary </h5>';
    html += '</div>';
    html +=
      '<div class="row table-responsive-md"><table class="table table-bordered mb-3"><thead><tr class="reportTableHeaderBg" ><th class="w-60">' +
      tableHead +
      '</th><th Total>Total</th><th Total>#positive</th><th Total>#negative</th></tr></thead><tbody>';
    for (let t = 0; t < array.length; t++) {
      html +=
        '<tr><td><b>' +
        array[t].name +
        '</b></td>' +
        '<td class="textalignright pr-1">' +
        array[t].count +
        '</td>' +
        '<td class="textalignright pr-1">' +
        array[t].positivecount +
        '</td>' +
        '<td class="textalignright pr-1">' +
        array[t].negativecount +
        '</td></tr>';
    }
    html += '</tbody></table></div>';
    $('#exportSheet').append(html);
  }
  //To generate Header for the records
  generateProjectSummarySectionHeader(index: any, header: any, array: any, tableHead: any) {

    var html = '<hr class="mt-0 mb-0" style="border-top: 1px solid black;" >';
    html += '<div class="row strict" id="' + header + '" >';
    html += '<h5>Section ' + index + ' : Project summary </h5>';
    html += '</div>';
    html +=
      '<div class="row table-responsive-md"><table class="table table-bordered mb-3"><thead><tr class="reportTableHeaderBg"><th colspan="1" class="w-30   border-right1pxBlack">Modules</th><th colspan="5" class="  border-right1pxBlack" >Entities</th><th colspan="3" class="  border-right1pxBlack">Scenarios</th><th colspan="5" class="  border-right1pxBlack">Activities</th></tr></tr><tr><th class="w-30  ">  </th><th class="border-left1pxBlk">Total</th><th >TF</th><th >UR</th><th >BF</th><th >XX</th><th class="border-left1pxBlk">Total</th><th >+ve</th><th >-ve</th><th class="border-left1pxBlk">PM(%)</th><th >SM(%)</th><th>DD(%)</th><th >DE(%)</th><th class="border-right1pxBlk">EX(%)</th></tr></thead><tbody>';
    for (let t = 0; t < array.length; t++) {
      html +=
        '<tr ><td><b>' +
        array[t].name +
        '</b></td>' +
        '<td class="textalignright border-left1pxBlk pr-1">' +
        array[t].count +
        '</td>' +
        '<td class="textalignright pr-1">' +
        array[t].TFcount +
        '</td>' +
        '<td class="textalignright pr-1">' +
        array[t].URcount +
        '</td>' +
        '<td class="textalignright pr-1">' +
        array[t].BFcount +
        '</td>' +
        '<td class="textalignright pr-1">' +
        array[t].XXcount +
        '</td>' +
        '<td class="textalignright border-left1pxBlk pr-1">' +
        array[t].scenariocount +
        '</td>' +
        '<td class="textalignright pr-1">' +
        array[t].positivecount +
        '</td>' +
        '<td class="textalignright pr-1">' +
        array[t].negativecount +
        '</td>' +
        '<td class="textalignright border-left1pxBlk pr-1">' +
        Math.round(array[t].personaPercent) +
        '%</td>' +
        '<td class="textalignright pr-1">' +
        Math.round(array[t].scopePercent) +
        '%</td>' +
        '<td class="textalignright pr-1">' +
        Math.round(array[t].ddPercent) +
        '%</td>' +
        '<td class="textalignright pr-1">' +
        Math.round(array[t].dePercent) +
        '%</td>' +
        '<td class="textalignright border-right1pxBlk pr-1">' +
        Math.round(array[t].exPercent) +
        '%</td></tr>';
    }
    html += '</tbody></table></div>';
    $('#exportSheet').append(html);
  }
  //To generate Header for the records
  generateTMSectionHeader(index: any, header: any, array: any, tableHead: any) {
    // var html = '<hr class="mt-0 mb-0" style="border-top: 1px solid black;" >';
    // html += '<div class="row strict" id="' + header + '" >';
    // html += '<h5>Section ' + index + ' : ' + header + ' </h5>';
    // html += '</div>';
    var html =
      '<div class="row table-responsive-md"><div class="col-md-4"><table class="table table-bordered mb-3"><thead><tr class="reportTableHeaderBg"><th class="w-60">' +
      tableHead +
      '</th><th Total>Total</th><th Total>+ve</th><th Total>-ve</th><th Total>%</th></tr></thead><tbody>';
    for (let t = 0; t < array.length; t++) {
      html +=
        '<tr><td><b>' +
        array[t].name +
        '</b></td>' +
        '<td class="textalignright pr-1">' +
        array[t].count +
        '</td>' +
        '<td class="textalignright pr-1">' +
        array[t].positive +
        '</td>' +
        '<td class="textalignright pr-1">' +
        array[t].negative +
        '</td>' +
        '<td class="textalignright pr-1">' +
        Math.round(array[t].percent) +
        '%</td></tr>';
    }
    html += '</tbody></table></div> <div class="col-md-4"></div><div class="col-md-4"></div></div>';
    $('#exportSheet').append(html);
  }
  generateTMLevelSectionHeader(
    index: any,
    header: any,
    array: any,
    tableHead: any
  ) {
    var levelAttrArray = ['L8', 'L7', 'L6', 'L5', 'L4', 'L123', 'Total'];
    var html = '<hr class="mt-0 mb-0" style="border-top: 1px solid black;" >';
    html += '<div class="row strict" id="' + header + '" >';
    html += '<h5>Section ' + index + ' : ' + header + ' </h5>';
    html += '</div>';
    html +=
      '<div class="row table-responsive-md"><div class="col-md-4"><table class="table levelwise table-bordered mb-3"><thead><tr class="reportTableHeaderBg"><th class="w-10">' +
      tableHead +
      '</th><th Total>Total</th><th Total>+ve</th><th Total>-ve</th><th Total>%</th></tr></thead><tbody>';

    for (let w = 0; w < levelAttrArray.length; w++) {
      for (let t = 0; t < array.length; t++) {
        if (levelAttrArray[w] == array[t].level) {
          html +=
            '<tr><td><b>' +
            levelAttrArray[w] +
            // '</td><td>' +
            // array[t].name +
            '</b></td><td class="textalignright" >' +
            array[t].count +
            '</td><td class="textalignright">' +
            array[t].positive +
            '</td><td class="textalignright">' +
            array[t].negative +
            '</td><td class="textalignright">' +
            Math.round(array[t].percent) +
            '% </td></tr>';
        }
      }
    }
    html += '</tbody></table></div><div class="col-md-4"></div><div class="col-md-4"></div></div>';
    $('#exportSheet').append(html);
  }
  generateLevelSectionHeader(
    index: any,
    header: any,
    array: any,
    tableHead: any
  ) {
    var html = '<hr class="mt-0 mb-0" style="border-top: 1px solid black;" >';
    html += '<div class="row strict" id="' + header + '" >';
    html += '<h5>Section ' + index + ' : ' + header + ' </h5>';
    html += '</div>';
    html =
      '<div class="row table-responsive-md"><div class="col-md-6"><table class="table levelwise table-bordered mb-3"><thead><tr class="reportTableHeaderBg" ><th class="w-30">' +
      tableHead +
      '</th><th>Total</th><th>L123</th><th>L4</th><th>L5</th><th>L6</th><th>L7</th><th>L8</th></tr></thead><tbody>';

    for (let t = 0; t < array.length; t++) {
      html +=
        '<tr><td><b>' +
        array[t].name +
        '</b></td><td class="textalignright" >' +
        array[t].total +
        '</td><td class="textalignright" >' +
        array[t].L123count +
        '</td><td class="textalignright" >' +
        array[t].L4count +
        '</td><td class="textalignright" >' +
        array[t].L5count +
        '</td><td class="textalignright" >' +
        array[t].L6count +
        '</td><td class="textalignright" >' +
        array[t].L7count +
        '</td><td class="textalignright" >' +
        array[t].L8count +
        '</td></tr>';
    }
    html += '</tbody></table></div><div class="col-md-6"></div></div>';
    $('#exportSheet').append(html);
  }

  generateLegends() {
    var html = '<hr class="mt-0 mb-0" style="border-top: 1px solid black;" >';
    html += '<div class="row strict" id="Abbreviations" >';
    html += '<h5>Section 4 : Abbreviations </h5>';
    html += '</div>';
    html +=
      '<div class="row table-responsive-md"><div class="col-md-6"><table class="table levelwise table-bordered mb-3"><thead><tr class="reportTableHeaderBg" ><th>Test types</th><th>Levels</th><th>Entity types</th><th>Tools</th></tr></thead><tbody>';
    html += '<tr><td><b>Mi</b> - Migration</td><td><b>L8</b> - Migration</td><td><b>TF</b> - Technical feature</td><td><b>PM</b> - Persona Mapper</td></tr>';
    html += '<tr><td><b>In</b> - Installation</td><td><b>L8</b> - Installation</td><td><b>UR</b> - User requirement</td><td><b>SM</b> - Scope Mapper</td></tr>';
    html += '<tr><td><b>Co</b> - Configuration</td><td><b>L8</b> - Configuration</td><td><b>BF</b> - Bussiness flow</td><td><b>DD</b> - Deep Diver</td></tr>';
    html += '<tr><td><b>Si</b> - System Integration</td><td><b>L8</b> - System Integration</td><td><b>XX</b> - Unspecified</td><td><b>DE</b> - Test Designer</td></tr>';
    html += '<tr><td><b>Pf</b> - Performance</td><td><b>L7</b> - Performance</td><td></td><td><b>EX</b> - Executor</td></tr>';
    html += '<tr><td><b>Se</b> - Security</td><td><b>L7</b> - Security</td></tr>';
    html += '<tr><td><b>Lo</b> - Load</td><td><b>L7</b> - Load</td></tr>';
    html += '<tr><td><b>Re</b> - Reliability</td><td><b>L7</b> - Reliability</td></tr>';
    html += '<tr><td><b>Us</b> - Usability</td><td><b>L7</b> - Usability</td></tr>';
    html += '<tr><td><b>Bc</b> - Browser Compatibility</td><td><b>L6</b> - Browser Compatibility</td></tr>';
    html += '<tr><td><b>Ec</b> - Environment Compatibility</td><td><b>L6</b> - Environment Compatibility</td></tr>';
    html += '<tr><td><b>Rb</b> - Requirement Behaviour</td><td><b>L5</b> - Requirement Behaviour</td></tr>';
    html += '<tr><td><b>Fb</b> - Flow Behaviour</td><td><b>L5</b> - Flow Behaviour</td></tr>';
    html += '<tr><td><b>Fe</b> - Feature Behaviour</td><td><b>L4</b> - Feature Behaviour</td></tr>';
    html += '<tr><td><b>Ac</b> - Access Control</td><td><b>L4</b> - Access Control</td></tr>';
    html += '<tr><td><b>Ui</b> - UI Interface</td><td><b>L123</b> - UI Interface</td></tr>';
    html += '<tr><td><b>St</b> - Structural Behaviour</td><td><b>L123</b> - Structural Behaviour</td></tr>';
    html += '</tbody></table></div>';

    $('#exportSheet').append(html);

    // var html = '<hr class="mt-0 mb-0" style="border-top: 1px solid black;" >';
    // html += '<div class="row strict"  >';
    // html += '<div class="col-md-4"  >';
    // html += '<h5>Test types : </h5>';
    // html += '<ul>';
    // html += '<li> Mi - Migration </li>';
    // html += '<li> In - Installation </li>';
    // html += '<li> Co - Configuration </li>';
    // html += '<li> Si - System Integration </li>';
    // html += '<li> Pf - Performance </li>';
    // html += '<li> Se - Security </li>';
    // html += '<li> Lo - Load </li>';
    // html += '<li> Re - Reliability </li>';
    // html += '<li> Us - Usability </li>';
    // html += '<li> Bc - Browser Compatibility </li>';
    // html += '<li> Ec - Environment Compatibility </li>';
    // html += '<li> Rb - Requirement Behaviour </li>';
    // html += '<li> Fb - Flow Behaviour </li>';
    // html += '<li> Fe - Feature Behaviour </li>';
    // html += '<li> Ac - Access Control </li>';
    // html += '<li> Ui - UI Interface </li>';
    // html += '<li> St - Structural Behaviour </li>';
    // html += '</ul>';
    // html += '</div>';
    // html += '<div class="col-md-4"  >';
    // html += '<h5>Levels : </h5>';
    // html += '<ul>';
    // html += '<li><b>L8 :</b></li>';
    // html += '<li>  - Migration </li>';
    // html += '<li>  - Installation </li>';
    // html += '<li>  - Configuration </li>';
    // html += '<li>  - System Integration </li>';
    // html += '<li><b>L7 :</b></li>';
    // html += '<li>  - Performance </li>';
    // html += '<li>  - Security </li>';
    // html += '<li>  - Load </li>';
    // html += '<li>  - Reliability </li>';
    // html += '<li>  - Usability </li>';
    // html += '<li><b>L6 :</b></li>';
    // html += '<li>  - Browser Compatibility </li>';
    // html += '<li>  - Environment Compatibility </li>';
    // html += '<li><b>L5 :</b></li>';
    // html += '<li>  - Requirement Behaviour </li>';
    // html += '<li>  - Flow Behaviour </li>';
    // html += '<li><b>L4 :</b></li>';
    // html += '<li>  - Feature Behaviour </li>';
    // html += '<li>  - Access Control </li>';
    // html += '<li><b>L123 :</b></li>';
    // html += '<li>  - UI Interface </li>';
    // html += '<li>  - Structural Behaviour </li>';
    // html += '</ul>';
    // html += '</div>';
    // html += '</div>';
    // $('#exportSheet').append(html);
  }
  generateTesttypeSectionHeader(
    index: any,
    header: any,
    array: any,
    tableHead: any
  ) {
    var html = '<hr class="mt-0 mb-0" style="border-top: 1px solid black;" >';
    html += '<div class="row strict" id="' + header + '" >';
    html += '<h5>Section ' + index + ' : ' + header + ' </h5>';
    html += '</div>';
    html +=
      '<div class="row table-responsive-md"><table class="table levelwise table-bordered mb-3"><thead><tr class="reportTableHeaderBg" ><th class="w-20">' +
      tableHead +
      '</th><th>Total</th><th title="Migration">Mi</th><th title="Installation">In</th><th title="Configuration">Co</th><th title="System Integration">Si</th><th title="Performance">Pf</th><th title="Security">Se</th><th title="Load">Lo</th><th title="Reliability">Re</th><th title="Usability">Us</th><th title="Browser Compatibility">Bc</th><th title="Environment Compatibility">Ec</th><th title="Requirement Behaviour">Rb</th><th title="Flow Behaviour">Fb</th><th title="Feature Behaviour">Fe</th><th title="Access Control">Ac</th><th title="UI Interface">Ui</th><th title="Structural Behaviour">St</th></tr></thead><tbody>';

    for (let t = 0; t < array.length; t++) {
      html +=
        '<tr><td><b>' +
        array[t].name +
        '</b></td><td class="textalignright" >' +
        array[t].total +
        '</td><td class="textalignright" >' +
        array[t].Micount +
        '</td><td class="textalignright" >' +
        array[t].Incount +
        '</td><td class="textalignright" >' +
        array[t].Cocount +
        '</td><td class="textalignright" >' +
        array[t].Sicount +
        '</td><td class="textalignright" >' +
        array[t].Pfcount +
        '</td><td class="textalignright" >' +
        array[t].Secount +
        '</td><td class="textalignright" >' +
        array[t].Locount +
        '</td><td class="textalignright" >' +
        array[t].Recount +
        '</td><td class="textalignright" >' +
        array[t].Uscount +
        '</td><td class="textalignright" >' +
        array[t].Bccount +
        '</td><td class="textalignright" >' +
        array[t].Eccount +
        '</td><td class="textalignright" >' +
        array[t].Rbcount +
        '</td><td class="textalignright" >' +
        array[t].Fbcount +
        '</td><td class="textalignright" >' +
        array[t].Fecount +
        '</td><td class="textalignright" >' +
        array[t].Account +
        '</td><td class="textalignright" >' +
        array[t].Uicount +
        '</td><td class="textalignright" >' +
        array[t].Stcount +
        '</td></tr>';
    }
    html += '</tbody></table></div>';
    $('#exportSheet').append(html);
  }
  //given an persona-> function returns the number and percentage of scenarios for this persona
  getCountForModules(module: any) {
    var scenario = {
      count: 0,
      percent: 0,
      name: '',
      id: '',
      positive: 0,
      negative: 0,
    };

    var scenarios = this.model.scenarios.filter(
      (scenario: any) => this.getModuleID(scenario.eID) == module.mID
    );
    for (let a = 0; a < scenarios.length; a++) {
      if (scenarios[a].cr == '+') {
        scenario.positive++;
      } else if (scenarios[a].cr == '-') {
        scenario.negative++;
      }
    }
    scenario.count = scenarios.length;
    if (scenarios.length != 0) {
      scenario.percent = (scenarios.length / this.model.scenarios.length) * 100;
    } else {
      scenario.percent = 0;
    }
    scenario.name = module.mName;
    scenario.id = module.mID;
    return scenario;
  }

  getModuleID(eID: any) {
    var eut: any = this.model.listOfEUTs.find(
      (e: any) => e.eID == eID
    );
    var foundModule: any = this.model.modules.find(
      (mod: any) => mod.mID == eut.mID
    );
    return foundModule.mID;
  }

  //given an test Type-> function returns the number and percentage of scenarios for this testType
  getCountForTestType(testType: any) {
    var scenario = {
      count: 0,
      percent: 0,
      name: '',
      symbol: '',
      level: '',
      positive: 0,
      negative: 0,
    };
    var scenarios = this.model.scenarios.filter(
      (scenario: any) => scenario.tID == testType.symbol
    );
    for (let a = 0; a < scenarios.length; a++) {
      if (scenarios[a].cr == '+') {
        scenario.positive++;
      } else if (scenarios[a].cr == '-') {
        scenario.negative++;
      }
    }
    scenario.count = scenarios.length;
    if (scenarios.length != 0) {
      scenario.percent = (scenarios.length / this.model.scenarios.length) * 100;
    } else {
      scenario.percent = 0;
    }
    scenario.name = testType.name;
    scenario.symbol = testType.symbol;
    scenario.level = testType.level;
    return scenario;
  }

  // given an module-> function returns the number and percentage of modules
  getCountsByEUT(entity: any) {
    var entityData = {
      count: 0,
      positivecount: 0,
      negativecount: 0,
      name: ''
    }
    entityData.name = entity.eName;
    var EUTscenarios = this.model.scenarios.filter(
      (eut: any) => eut.eID == entity.eID
    );
    entityData.count = EUTscenarios.length;
    for (var i = 0; i < EUTscenarios.length; i++) {
      if (EUTscenarios[i].cr == "+") {
        entityData.positivecount++;
      }
      if (EUTscenarios[i].cr == "-") {
        entityData.negativecount++;
      }
    }
    return entityData;
  }
  // given an module-> function returns the number and percentage of modules
  getCountsByModule(module: any) {
    var moduleData = {
      count: 0,
      TFcount: 0,
      URcount: 0,
      BFcount: 0,
      XXcount: 0,
      scenariocount: 0,
      positivecount: 0,
      negativecount: 0,
      personaPercent: 0,
      scopePercent: 0,
      // mapsPercent: 0,
      ddPercent: 0,
      dePercent: 0,
      exPercent: 0,
      name: '',
    };
    moduleData.name = module.mName;
    var moduleEUTs = this.model.listOfEUTs.filter(
      (eut: any) => eut.mID == module.mID
    );
    moduleData.count = moduleEUTs.length;
    for (let a = 0; a < moduleEUTs.length; a++) {
      if (moduleEUTs[a].eType == 'TF') {
        moduleData.TFcount++;
      } else if (moduleEUTs[a].eType == 'UR') {
        moduleData.URcount++;
      } else if (moduleEUTs[a].eType == 'BF') {
        moduleData.BFcount++;
      } else if (moduleEUTs[a].eType == 'XX') {
        moduleData.XXcount++;
      }
    }
    var scenarios = this.model.scenarios.filter(
      (scenario: any) => this.getModuleID(scenario.eID) == module.mID
    );
    for (let a = 0; a < scenarios.length; a++) {
      if (scenarios[a].cr == '+') {
        moduleData.positivecount++;
      } else if (scenarios[a].cr == '-') {
        moduleData.negativecount++;
      }
    }
    moduleData.scenariocount = scenarios.length;
    if (moduleEUTs.length != 0) {
      var ddCount = 0;
      var deCount = 0;
      var exCount = 0;
      var percount = 0;
      var scopecount = 0;
      for (var j = 0; j < moduleEUTs.length; j++) {

        for (var k = 0; k < this.model.EUTdetails.length; k++) {
          if (moduleEUTs[j].eID == this.model.EUTdetails[k].eID) {
            ddCount++;
          }
        }
        for (var p = 0; p < this.model.personaMap.length; p++) {
          if (moduleEUTs[j].eID == this.model.personaMap[p].eID) {
            percount++;
            break;
          }
        }
        for (var s = 0; s < this.model.scopeMap.length; s++) {
          if (moduleEUTs[j].eID == this.model.scopeMap[s].eID) {
            scopecount++;
            break;
          }
        }
        for (var l = 0; l < this.model.scenarios.length; l++) {
          if (moduleEUTs[j].eID == this.model.scenarios[l].eID) {
            deCount++;
            break;
          }
        }
        var foundScenarios = this.model.scenarios.filter(
          (eut: any) => eut.eID == moduleEUTs[j].eID
        );
        // var scenMatched = this.model.scenarios.find(
        //   (sec: any) => sec.scenID == suite.scenarios[a]
        // );
        for (var n = 0; n < foundScenarios.length; n++) {
          for (var m = 0; m < this.model.runInfo.length; m++) {
            if (foundScenarios[n].scenID == this.model.runInfo[m].scenID) {
              exCount++;
              break;
            }
          }
          break;
        }

      }
      // console.log("exCount",exCount,moduleEUTs.length)
      moduleData.ddPercent = (ddCount / moduleEUTs.length) * 100;
      moduleData.personaPercent = (percount / moduleEUTs.length) * 100;
      moduleData.scopePercent = (scopecount / moduleEUTs.length) * 100;
      moduleData.dePercent = (deCount / moduleEUTs.length) * 100;
      moduleData.exPercent = (exCount / moduleEUTs.length) * 100;
    } else {
      // scenario.percent = 0;
    }
    return moduleData;
  }

  // given an entity-> function returns the number and percentage of scenarios for this entity
  getCountForEntity(entity: any) {
    var scenario = {
      count: 0,
      percent: 0,
      eID: '',
      name: '',
      eType: '',
      positive: 0,
      negative: 0,
    };
    var scenarios = this.model.scenarios.filter(
      (scenario: any) => scenario.eID == entity.eID
    );
    for (let a = 0; a < scenarios.length; a++) {
      if (scenarios[a].cr == '+') {
        scenario.positive++;
      } else if (scenarios[a].cr == '-') {
        scenario.negative++;
      }
    }
    scenario.count = scenarios.length;
    if (scenarios.length != 0) {
      scenario.percent = (scenarios.length / this.model.scenarios.length) * 100;
    } else {
      scenario.percent = 0;
    }
    scenario.eID = entity.eID;
    scenario.name = entity.eName;
    scenario.eType = entity.eType;
    return scenario;
  }

  getCountForLevelwise(module: any) {
    var scenario = {
      name: '',
      total: 0,
      L8count: 0,
      L7count: 0,
      L6count: 0,
      L5count: 0,
      L4count: 0,
      L123count: 0,
    }
    var moduleEUTs = this.model.listOfEUTs.filter(function (entity: any) {
      if (entity.mID == module.mID) {
        return entity;
      }
    });

    for (var i = 0; i < moduleEUTs.length; i++) {
      for (var j = 0; j < this.model.scenarios.length; j++) {
        if (moduleEUTs[i].eID == this.model.scenarios[j].eID) {
          scenario.total++;
          var scenarioLevel = this.model.scenarios[j].attribute.level;
          if (scenarioLevel == 'L8') {
            scenario.L8count++;
          }
          if (scenarioLevel == 'L7') {
            scenario.L7count++;
          }
          if (scenarioLevel == 'L6') {
            scenario.L6count++;
          }
          if (scenarioLevel == 'L5') {
            scenario.L5count++;
          }
          if (scenarioLevel == 'L4') {
            scenario.L4count++;
          }
          if (scenarioLevel == 'L123') {
            scenario.L123count++;
          }
        }
      }
    }
    scenario.name = module.mName;
    return scenario;
  }
  getCountForType(module: any) {
    var scenario = {
      name: '',
      total: 0,
      Micount: 0,
      Incount: 0,
      Cocount: 0,
      Sicount: 0,
      Pfcount: 0,
      Secount: 0,
      Locount: 0,
      Recount: 0,
      Uscount: 0,
      Bccount: 0,
      Eccount: 0,
      Rbcount: 0,
      Fbcount: 0,
      Fecount: 0,
      Account: 0,
      Uicount: 0,
      Stcount: 0,
    };


    var moduleEUTs = this.model.listOfEUTs.filter(function (entity: any) {
      if (entity.mID == module.mID) {
        return entity;
      }
    });

    for (var i = 0; i < moduleEUTs.length; i++) {
      for (var j = 0; j < this.model.scenarios.length; j++) {
        if (moduleEUTs[i].eID == this.model.scenarios[j].eID) {
          scenario.total++;
          var scenarioSymbol = this.model.scenarios[j].attribute.symbol;
          if (scenarioSymbol == 'Mi') {
            scenario.Micount++;
          }
          if (scenarioSymbol == 'In') {
            scenario.Incount++;
          }
          if (scenarioSymbol == 'Co') {
            scenario.Cocount++;
          }
          if (scenarioSymbol == 'Si') {
            scenario.Sicount++;
          }
          if (scenarioSymbol == 'Pf') {
            scenario.Pfcount++;
          }
          if (scenarioSymbol == 'Se') {
            scenario.Secount++;
          }
          if (scenarioSymbol == 'Lo') {
            scenario.Locount++;
          }
          if (scenarioSymbol == 'Re') {
            scenario.Recount++;
          }
          if (scenarioSymbol == 'Us') {
            scenario.Uscount++;
          }
          if (scenarioSymbol == 'Bc') {
            scenario.Bccount++;
          }
          if (scenarioSymbol == 'Ec') {
            scenario.Eccount++;
          }
          if (scenarioSymbol == 'Rb') {
            scenario.Rbcount++;
          }
          if (scenarioSymbol == 'Fb') {
            scenario.Fbcount++;
          }
          if (scenarioSymbol == 'Fe') {
            scenario.Fecount++;
          }
          if (scenarioSymbol == 'Ac') {
            scenario.Account++;
          }
          if (scenarioSymbol == 'Ui') {
            scenario.Uicount++;
          }
          if (scenarioSymbol == 'St') {
            scenario.Stcount++;
          }
        }

      }
    }
    scenario.name = module.mName;
    return scenario;

  }
  // given a level-> function returns the number and percentage of scenarios for this entity

  getCountForLevel(level: any) {
    var scenario = {
      count: 0,
      percent: 0,
      name: '',
      symbol: '',
      level: '',
      positive: 0,
      negative: 0,
    };


    var scenarios = this.model.scenarios.filter(function (scenario: any) {
      if (level == scenario.attribute.level) {
        return scenario;
      }
    });
    for (let a = 0; a < scenarios.length; a++) {
      if (scenarios[a].cr == '+') {
        scenario.positive++;
      } else if (scenarios[a].cr == '-') {
        scenario.negative++;
      }
    }
    scenario.count = scenarios.length;
    if (scenarios.length != 0) {
      scenario.percent = (scenarios.length / this.model.scenarios.length) * 100;
    } else {
      scenario.percent = 0;
    }
    // scenario.name = attribute.name;
    // scenario.symbol = attribute.symbol;
    scenario.level = level;
    return scenario;
  }
  // given a suite-> function returns the number and percentage of scenarios for this entity

  getCountForSuites(suite: any) {
    var scenario = {
      count: 0,
      percent: 0,
      scenarios: [],
      name: '',
      positive: 0,
      negative: 0,
    };
    for (let a = 0; a < suite.scenarios.length; a++) {
      var scenMatched = this.model.scenarios.find(
        (sec: any) => sec.scenID == suite.scenarios[a]
      );
      if (scenMatched != undefined) {
        if (scenMatched.cr == '+') {
          scenario.positive++;
        } else if (scenMatched.cr == '-') {
          scenario.negative++;
        }
      }
    }
    scenario.count = suite.scenarios.length;
    if (suite.scenarios.length != 0) {
      scenario.percent =
        (suite.scenarios.length / this.model.scenarios.length) * 100;
    } else {
      scenario.percent = 0;
    }
    scenario.scenarios = suite.scenarios;
    scenario.name = suite.suiteName;
    return scenario;
  }

  // To generate suites of all scenarios
  generateScenariosForTestManager() {
    var scenarioRadioArray = ['Modules', 'EUT', 'Test', 'Levels', 'Suites'];
    var eutTypes = ['TF', 'UR', 'BF', 'XX'];
    var attributesArray = this.clubbedAttributesArray;
    var finalEUTListArray = [];
    var finalTestListArray = [];
    var finalModulesListArray = [];
    var finalLevelListArray = [];
    var finalSuiteListArray = [];
    let count = 1;
    for (var i = 0; i < scenarioRadioArray.length; i++) {
      if (scenarioRadioArray[i] == 'EUT') {
        for (var j = 0; j < eutTypes.length; j++) {
          for (var k = 0; k < this.model.listOfEUTs.length; k++) {
            if (eutTypes[j] == this.model.listOfEUTs[k].eType) {
              finalEUTListArray.push(
                this.getCountForEntity(this.model.listOfEUTs[k])
              );
            }
          }
        }
      }
      if (scenarioRadioArray[i] == 'Modules') {
        for (var n = 0; n < this.model.modules.length; n++) {
          finalModulesListArray.push(this.getCountForModules(this.model.modules[n]));
        }
      }
      if (scenarioRadioArray[i] == 'Test') {
        for (var l = 0; l < attributesArray.length; l++) {
          finalTestListArray.push(this.getCountForTestType(attributesArray[l]));
        }
      }
      if (scenarioRadioArray[i] == 'Suites') {
        for (var m = 0; m < this.model.suites.length; m++) {
          finalSuiteListArray.push(
            this.getCountForSuites(this.model.suites[m])
          );
        }
      }
      // if (scenarioRadioArray[i] == 'Persona') {
      //   for (var n = 0; n < this.model.persona.length; n++) {
      //     finalModulesListArray.push(
      //       this.getCountForModules(this.model.persona[n])
      //     );
      //   }
      // }
      if (scenarioRadioArray[i] == 'Levels') {
        for (var o = 0; o < this.levels.length; o++) {
          finalLevelListArray.push(this.getCountForLevel(this.levels[o]));
        }
      }
    }

    this.generateTMContentlist(
      finalEUTListArray,
      finalTestListArray,
      finalModulesListArray,
      finalLevelListArray,
      finalSuiteListArray
    );
    if (finalEUTListArray.length > 0) {
      this.generateTMSectionHeader(
        count,
        'EUT-wise',
        finalEUTListArray,
        'Entity Type'
      );
      count++;
    }
    if (finalTestListArray.length > 0) {
      this.generateTMSectionHeader(
        count,
        'Test-wise',
        finalTestListArray,
        'Test Type'
      );
      count++;
    }
    if (finalModulesListArray.length > 0) {
      this.generateTMSectionHeader(
        count,
        'Module-wise',
        finalModulesListArray,
        'Module'
      );
      count++;
    }
    if (finalLevelListArray.length > 0) {
      this.generateTMLevelSectionHeader(
        count,
        'Level-wise',
        finalLevelListArray,
        'Level'
      );
      count++;
    }
    if (finalSuiteListArray.length > 0) {
      this.generateTMSectionHeader(
        count,
        'Suite-wise',
        finalSuiteListArray,
        'Suite Name'
      );
      count++;
    }
    // for (var i = 0; i < model.suites.length; i++) {
    //   indexVal = indexVal + 1;
    //   secIndex = 0;
    //   generateHeader(indexVal, model.suites[i].suiteName);
    //   for (var j = 0; j < model.suites[i].scenarios.length; j++) {
    //     this.matchedScenario = model.scenarios.find(sec => sec.scenID == model.suites[i].scenarios[j].trim());
    //     if (this.matchedScenario) {
    //       secIndex = secIndex + 1;
    //       generateScenarioList(indexVal, secIndex, this.matchedScenario.description, this.matchedScenario.cr, this.matchedScenario.priority)
    //     }
    //   }
    // }
  }

  generateProjectSummaryTable() {
    var projectSummaryArray = [];
    var count = 1
    // this.generateProjectSummaryContentlist();
    for (var i = 0; i < this.model.modules.length; i++) {
      projectSummaryArray.push(
        this.getCountsByModule(this.model.modules[i])
      );
    }
    var totalObj = {
      "count": 0,
      "TFcount": 0,
      "URcount": 0,
      "BFcount": 0,
      "XXcount": 0,
      "scenariocount": 0,
      "positivecount": 0,
      "negativecount": 0,
      "personaPercent": "",
      "scopePercent": "",
      "ddPercent": "",
      "dePercent": "",
      "exPercent": "",
      "name": "Total"
    }
    for (var j = 0; j < projectSummaryArray.length; j++) {
      totalObj.count += projectSummaryArray[j].count;
      totalObj.TFcount += projectSummaryArray[j].TFcount;
      totalObj.URcount += projectSummaryArray[j].URcount;
      totalObj.BFcount += projectSummaryArray[j].BFcount;
      totalObj.XXcount += projectSummaryArray[j].XXcount;
      totalObj.scenariocount += projectSummaryArray[j].scenariocount;
      totalObj.positivecount += projectSummaryArray[j].positivecount;
      totalObj.negativecount += projectSummaryArray[j].negativecount;
    }
    projectSummaryArray.push(totalObj);
    if (projectSummaryArray.length > 0) {
      this.generateProjectSummarySectionHeader(
        count,
        'projectSummary',
        projectSummaryArray,
        'Modules'
      );
    }
  }
  generateDesignSummaryTable() {
    var scenarioRadioArray = ['Modules', 'Test', 'Levels', 'Type', 'level'];
    var eutTypes = ['TF', 'UR', 'BF', 'XX'];
    var attributesArray = this.clubbedAttributesArray;
    var finalTestListArray = [];
    var finalModulesListArray = [];
    var finalLevelListArray = [];
    var finalTestTypeListArray = [];
    var finalLevelwiseListArray = [];
    let count = 2;
    for (var i = 0; i < scenarioRadioArray.length; i++) {

      if (scenarioRadioArray[i] == 'Modules') {
        for (var n = 0; n < this.model.modules.length; n++) {
          finalModulesListArray.push(this.getCountForModules(this.model.modules[n]));
        }
        // console.log("finalModulesListArray",finalModulesListArray);
        var totalObj = {
          "count": 0,
          "positive": 0,
          "negative": 0,
          "name": "Total",
          "percent": 100
        };
        for (var a = 0; a < finalModulesListArray.length; a++) {
          totalObj.count += finalModulesListArray[a].count;
          totalObj.positive += finalModulesListArray[a].positive;
          totalObj.negative += finalModulesListArray[a].negative;
        }
        finalModulesListArray.push(totalObj);
      }
      if (scenarioRadioArray[i] == 'Test') {
        for (var l = 0; l < attributesArray.length; l++) {
          finalTestListArray.push(this.getCountForTestType(attributesArray[l]));
        }
        // console.log("finalTestListArray",finalTestListArray);
        var totalObj = {
          "count": 0,
          "positive": 0,
          "negative": 0,
          "name": "Total",
          "percent": 100
        };
        for (var b = 0; b < finalTestListArray.length; b++) {
          totalObj.count += finalTestListArray[b].count;
          totalObj.positive += finalTestListArray[b].positive;
          totalObj.negative += finalTestListArray[b].negative;
        }
        finalTestListArray.push(totalObj);
      }


      if (scenarioRadioArray[i] == 'Levels') {
        for (var o = 0; o < this.levels.length; o++) {
          finalLevelListArray.push(this.getCountForLevel(this.levels[o]));
        }
        var totallevelObj = {
          "count": 0,
          "positive": 0,
          "negative": 0,
          "level": "Total",
          "percent": 100,
          "name": "",
          "symbol": ""
        };
        for (var c = 0; c < finalLevelListArray.length; c++) {
          totallevelObj.count += finalTestListArray[c].count;
          totallevelObj.positive += finalLevelListArray[c].positive;
          totallevelObj.negative += finalLevelListArray[c].negative;
        }
        finalLevelListArray.push(totallevelObj);
      }

      if (scenarioRadioArray[i] == 'Type') {
        for (var p = 0; p < this.model.modules.length; p++) {
          finalTestTypeListArray.push(this.getCountForType(this.model.modules[p]));
        }

        var scenario = {
          name: 'Total',
          total: 0,
          Micount: 0,
          Incount: 0,
          Cocount: 0,
          Sicount: 0,
          Pfcount: 0,
          Secount: 0,
          Locount: 0,
          Recount: 0,
          Uscount: 0,
          Bccount: 0,
          Eccount: 0,
          Rbcount: 0,
          Fbcount: 0,
          Fecount: 0,
          Account: 0,
          Uicount: 0,
          Stcount: 0,
        };
        for (var d = 0; d < finalTestTypeListArray.length; d++) {
          scenario.total += finalTestTypeListArray[d].total;
          scenario.Micount += finalTestTypeListArray[d].Micount;
          scenario.Incount += finalTestTypeListArray[d].Incount;
          scenario.Cocount += finalTestTypeListArray[d].Cocount;
          scenario.Sicount += finalTestTypeListArray[d].Sicount;
          scenario.Pfcount += finalTestTypeListArray[d].Pfcount;
          scenario.Secount += finalTestTypeListArray[d].Secount;
          scenario.Locount += finalTestTypeListArray[d].Locount;
          scenario.Recount += finalTestTypeListArray[d].Recount;
          scenario.Uscount += finalTestTypeListArray[d].Uscount;
          scenario.Bccount += finalTestTypeListArray[d].Bccount;
          scenario.Eccount += finalTestTypeListArray[d].Eccount;
          scenario.Rbcount += finalTestTypeListArray[d].Rbcount;
          scenario.Fbcount += finalTestTypeListArray[d].Fbcount;
          scenario.Fecount += finalTestTypeListArray[d].Fecount;
          scenario.Account += finalTestTypeListArray[d].Account;
          scenario.Uicount += finalTestTypeListArray[d].Uicount;
          scenario.Stcount += finalTestTypeListArray[d].Stcount;
        }
        finalTestTypeListArray.push(scenario);
      }
      if (scenarioRadioArray[i] == 'level') {
        for (var q = 0; q < this.model.modules.length; q++) {
          finalLevelwiseListArray.push(this.getCountForLevelwise(this.model.modules[q]));
        }
        var totallevel = {
          "total": 0,
          "L123count": 0,
          "L4count": 0,
          "L5count": 0,
          "L6count": 0,
          "name": "Total",
          "L7count": 0,
          "L8count": 0
        };
        for (var e = 0; e < finalLevelwiseListArray.length; e++) {
          totallevel.total += finalLevelwiseListArray[e].total;
          totallevel.L123count += finalLevelwiseListArray[e].L123count;
          totallevel.L4count += finalLevelwiseListArray[e].L4count;
          totallevel.L5count += finalLevelwiseListArray[e].L5count;
          totallevel.L6count += finalLevelwiseListArray[e].L6count;
          totallevel.L7count += finalLevelwiseListArray[e].L7count;
          totallevel.L8count += finalLevelwiseListArray[e].L8count;
        }
        finalLevelwiseListArray.push(totallevel);
      }
    }

    this.generateDesignSumContentlist(
      finalModulesListArray,
      finalTestListArray,
      finalLevelListArray,
      finalTestTypeListArray,
      finalLevelwiseListArray
    );



    if (finalLevelListArray.length > 0) {
      this.generateTMLevelSectionHeader(
        count,
        'Scenario distribution by Level, Module & Type',
        finalLevelListArray,
        'Level'
      );
      count++;
    }
    if (finalModulesListArray.length > 0) {
      this.generateTMSectionHeader(
        count,
        'Module-wise',
        finalModulesListArray,
        'Modules'
      );
      // count++;
    }
    if (finalTestListArray.length > 0) {
      this.generateTMSectionHeader(
        count,
        'Test-wise',
        finalTestListArray,
        'Test Type'
      );
      // count++;
    }

    if (finalTestTypeListArray.length > 0) {
      this.generateTesttypeSectionHeader(
        count,
        'Module wise scenarios by Type & Level',
        finalTestTypeListArray,
        'Modules'
      );
      // count++;
    }
    if (finalTestTypeListArray.length > 0) {
      this.generateLevelSectionHeader(
        count,
        'Levels',
        finalLevelwiseListArray,
        'Modules'
      );
      // count++;
    }
    // this.generateLegends();
    // var designSummaryArray = [];
    // var count = 1
    // this.generateDesignSummaryContentlist();
    // for (var i = 0; i < this.model.listOfEUTs.length; i++) {
    //   designSummaryArray.push(
    //     this.getCountsByEUT(this.model.listOfEUTs[i])
    //   );
    // }
    // if (designSummaryArray.length > 0) {
    //   this.generateDesignSummarySectionHeader(
    //     count,
    //     'designSummary',
    //     designSummaryArray,
    //     'Entity'
    //   );
    // }
  }
  // new code close
  generateTasksForTaskplanner() {
    let selectedPlanName = window.localStorage.getItem('selectedPlanname');
    var html = '<h4>[' + selectedPlanName + ']</h4>';
    $('#entityDetails').append(html);
    let taskPlannerTableContentArray = ['Summary', 'Task details'];
    this.generateContentlist(taskPlannerTableContentArray, 'Task Planner');
    html = '<hr class="mt-0 mb-0" style="border-top: 1px solid black;" >';
    $('#exportSheet').append(html);
    for (var i = 0; i < taskPlannerTableContentArray.length; i++) {
      this.generateTaskPlannerContent(
        i + 1,
        taskPlannerTableContentArray[i],
        selectedPlanName
      );
    }
  }

  generateTaskPlannerContent(index: any, type: any, selectedPlanName: any) {
    var tempPlanTasksList = [];
    for (var i = 0; i < this.model.sprintTasks.length; i++) {
      if (this.model.sprintTasks[i].sprintName == selectedPlanName) {
        tempPlanTasksList.push(this.model.sprintTasks[i]);
      }
    }
    var html = '<div class="row strict" id="' + type + '" >';
    if (type == 'Summary') {
      html += '<h5>Section   ' + index + '  : ' + type + '</h5>';
    } else if (type == 'Task details') {
      // console.log("type", type);
      html += '<hr class="mt-0 mb-0" style="border-top: 1px solid black;" >';
      html += '<h5>Section   ' + index + '  : ' + type + '</h5>';
    }

    html += '</div>';
    $('#exportSheet').append(html);
    if (type == 'Summary') {
      // console.log("tempPlanTasksList", tempPlanTasksList);
      var designTasksCount = 0;
      var validateTasksCount = 0;
      var tasksCountTF = [];
      var tasksCountUR = [];
      var tasksCountBF = [];
      for (var i = 0; i < tempPlanTasksList.length; i++) {
        if (
          tempPlanTasksList[i].toolType == 'pm' ||
          tempPlanTasksList[i].toolType == 'im' ||
          tempPlanTasksList[i].toolType == 'sm' ||
          tempPlanTasksList[i].toolType == 'dd' ||
          tempPlanTasksList[i].toolType == 'de' ||
          tempPlanTasksList[i].toolType == 'ex'
        ) {
          if (tempPlanTasksList[i].toolType == 'de') {
            designTasksCount++;
          } else if (tempPlanTasksList[i].toolType == 'ex') {
            validateTasksCount++;
          }
          if (tempPlanTasksList[i].entityType == 'TF') {
            tasksCountTF.push(tempPlanTasksList[i].entity_Id);
          } else if (tempPlanTasksList[i].entityType == 'UR') {
            tasksCountUR.push(tempPlanTasksList[i].entity_Id);
          } else if (tempPlanTasksList[i].entityType == 'BF') {
            tasksCountBF.push(tempPlanTasksList[i].entity_Id);
          }
        } else {
          // console.log(tempPlanTasksList[i]);
        }
      }
      html =
        '<div class="row table-responsive-md"><table class="table table-bordered textalignright"><tbody>';
      html +=
        '<tr><td class="textalignleft">Total number of tasks</td><td >' +
        tempPlanTasksList.length +
        '</td></tr>';
      html +=
        '<tr class="textalignleft"><td>Task-type details</td><td></td></tr>';
      html +=
        '<tr><td>#Design tasks</td><td>' + designTasksCount + '</td></tr>';
      html +=
        '<tr><td>#Validation tasks</td><td>' +
        validateTasksCount +
        '</td></tr>';
      html +=
        '<tr class="textalignleft"><td>Entity-wise details</td><td></td></tr>';
      html +=
        '<tr><td>#Technical features</td><td>' +
        this.removeDuplicates(tasksCountTF).length +
        '</td></tr>';
      html +=
        '<tr><td>#User requirements</td><td>' +
        this.removeDuplicates(tasksCountUR).length +
        '</td></tr>';
      html +=
        '<tr><td>#Business flows</td><td>' +
        this.removeDuplicates(tasksCountBF).length +
        '</td></tr>';
      html +=
        '<tr class="textalignleft"><td>Test-type details</td><td></td></tr>';
      for (let k = 0; k < this.clubbedAttributesArray.length; k++) {
        var attributeTaskCount = 0;
        for (var l = 0; l < tempPlanTasksList.length; l++) {
          if (this.clubbedAttributesArray[k].name == tempPlanTasksList[l].attribute) {
            attributeTaskCount++;
          }
        }
        if (attributeTaskCount != 0) {
          html +=
            '<tr><td>' +
            this.clubbedAttributesArray[k].name +
            '</td><td>' +
            attributeTaskCount +
            '</td></tr>';
        }
      }
      html += '</tbody></table></div>';
      $('#exportSheet').append(html);
    } else {
      if (tempPlanTasksList.length != 0) {
        // console.log("tempPlanTasksList", tempPlanTasksList);
        // html =
        //   '<div class="row table-responsive-md"><table class="table table-bordered "><thead><tr><th class="w-75">Task</th><th>Assigned</th><th>Status</th></tr></thead><tbody>';
        // for (var j = 0; j < tempPlanTasksList.length; j++) {
        //   html += '<tr style="border: 1px solid black" >';
        //   html += '<td>' + tempPlanTasksList[j].task_desc + '</td>';
        //   html += '<td>' + tempPlanTasksList[j].assigneduser + '</td>';
        //   if (tempPlanTasksList[j].checked == true) {
        //     html +=
        //       '<td><fa-icon class="fa menuItemsClrBlack" [icon]="faCheckCircle"></fa-icon></td>';
        //   } else {
        //     html +=
        //       '<td><fa-icon class="fa menuItemsClrBlack" [icon]="faCircle"></fa-icon></td>';
        //   }
        //   html += '</tr>';
        // }
        // html += '</tbody></table></div>';

        this.finalSprintTasksArray = [];
        for (var i = 0; i < tempPlanTasksList.length; i++) {

          if (this.finalSprintTasksArray.length == 0) {
            let newObj = {
              "entity_Id": tempPlanTasksList[i].entity_Id,
              "assigneduser": tempPlanTasksList[i].assigneduser,
              "description": tempPlanTasksList[i].description,
              "checked": tempPlanTasksList[i].checked,
              "tasks": [' ' + tempPlanTasksList[i].task_desc + '  ']
            }
            this.finalSprintTasksArray.push(newObj);
          } else {
            var found = false;
            for (var k = 0; k < this.finalSprintTasksArray.length; k++) {
              if (this.finalSprintTasksArray[k].entity_Id == tempPlanTasksList[i].entity_Id) {
                this.finalSprintTasksArray[k].tasks.push(tempPlanTasksList[i].task_desc);
                found = true;
              }
            }
            if (found == false) {
              let obj = {
                "entity_Id": tempPlanTasksList[i].entity_Id,
                "assigneduser": tempPlanTasksList[i].assigneduser,
                "description": tempPlanTasksList[i].description,
                "checked": tempPlanTasksList[i].checked,
                "tasks": [' ' + tempPlanTasksList[i].task_desc + '  ']
              }
              this.finalSprintTasksArray.push(obj);
            }
          }

        }
        // console.log("this.finalSprintTasksArray", this.finalSprintTasksArray);
        html =
          ''
        for (var l = 0; l < this.finalSprintTasksArray.length; l++) {
          html +=
            '<div class="row table-responsive-md"><ul ><b>' + this.finalSprintTasksArray[l].description + ' &nbsp&nbsp&nbsp&nbsp&nbsp'
          if (this.finalSprintTasksArray[l].checked == true) {
            html +=
              '- Completed';
          } else {
            html +=
              '- Pending';
          }
          for (var m = 0; m < this.finalSprintTasksArray[l].tasks.length; m++) {
            html += '<ul class="paddingleft10px" >- ' + this.finalSprintTasksArray[l].tasks[m] + '</ul>'
          }
          html += '</ul></div>'
        }

      } else {
        html = '<div class="row strict">';
        html +=
          '<div class="alert alert-warning"><strong><div style="text-align: center;">There is no tasks to show. Go and check sprint planner.</div></strong></div>';
        html += '</div>';
      }
      $('#exportSheet').append(html);
    }
  }
  // When the user scrolls down 20px from the top of the document, show the button
  // $window.onscroll = function () {
  //   scrollFunction();
  // };



  //  scrollFunction() {
  //   if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
  //     myTopScrollBtn.style.display = "block";
  //   } else {
  //     myTopScrollBtn.style.display = "none";
  //   }
  // }

  // When the user clicks on the button, scroll to the top of the document
  scrollToTopFunction = function () {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  //To generate notes
  generateNotes() {
    for (var i = 0; i < this.clubbedAttributesArray.length; i++) {
      var matchedNote = this.model.myNotes.find(
        (sec: any) => sec.testType == this.clubbedAttributesArray[i].symbol
      );
      if (matchedNote) {
        this.indexVal = this.indexVal + 1;
        var secIndex = 0;
        this.generateHeader(this.indexVal, this.clubbedAttributesArray[i].name);
        for (var j = 0; j < this.model.myNotes.length; j++) {
          secIndex = secIndex + 1;
          if (
            this.clubbedAttributesArray[i].symbol == this.model.myNotes[j].testType
          ) {
            this.generateNotesSublist(
              this.model.myNotes[j].noteInfo,
              this.model.myNotes[j].noteType,
              secIndex
            );
          }
        }
      }
    }

    // for (var i = 0; i < model.myNotes.length; i++) {
    //   indexVal = indexVal + 1;
    //   secIndex = 0;
    //   generateHeader(indexVal, model.myNotes[i].noteInfo);

    // }
  }
  // $('#cmd').click(function () {
  //   const filename = 'ExportedReport.pdf';
  //   html2canvas(document.querySelector('#nodeToRenderAsPDF')).then(canvas => {
  //     let pdf = new jsPDF('p', 'mm', 'a4');
  //     pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 0, 0, 211, 298);
  //     pdf.save(filename);
  //   });
  // });

  // To download the page into PDF

  // $('#cmd').click(function () {
  //   var pdf = new jsPDF('portrait', 'mm', 'a4');
  //   // source can be HTML-formatted string, or a reference
  //   // to an actual DOM element from which the text will be scraped.
  //   source = $('#sourceData')[0];

  //   // we support special element handlers. Register them with jQuery-style
  //   // ID selector for either ID or node name. ("#iAmID", "div", "span" etc.)
  //   // There is no support for any other type of selectors
  //   // (class, of compound) at this time.
  //   specialElementHandlers = {
  //     // element with id of "bypass" - jQuery style selector
  //     '#bypassme': function (element, renderer) {
  //       // true = "handled elsewhere, bypass text extraction"
  //       return true;
  //     },
  //     '#editor': function (element, renderer) {
  //       return true;
  //     }
  //   };
  //   margins = {
  //     top: 5,
  //     bottom: 5,
  //     left: 10,
  //     width: 170
  //   };
  //   // all coords and widths are in jsPDF instance's declared units
  //   // 'inches' in this case
  //   pdf.fromHTML(
  //     source, // HTML string or DOM elem ref.
  //     margins.left, // x coord
  //     margins.top, { // y coord
  //     'width': margins.width, // max width of content on PDF
  //     'elementHandlers': specialElementHandlers
  //   },

  //     function (dispose) {
  //       // dispose: object with X, Y of the last line add to the PDF
  //       // this allow the insertion of new lines after html
  //       pdf.save('Report.pdf');
  //     }, margins);
  //   // if (autoDownload == 'true') {
  //   //   window.localStorage.removeItem("autoDownload");
  //   //   window.localStorage.removeItem("exportedData");
  //   //   window.localStorage.removeItem("Entities");
  //   //   window.localStorage.removeItem("scenarioEntity");
  //   //   window.close();
  //   // }
  // });
}

//   }

// }
// }
